/* eslint-disable no-mixed-spaces-and-tabs */
const TrackJSON = [
    {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "柬埔寨返回",
    "bzzzytjd": "中国籍，从柬埔寨回国。4月10日，从柬埔寨金边乘LQ908航班飞往中国广州。11日，经广州白云机场入境，入境时体温正常，自觉有嗅觉减弱，健康申报14天内服用药物，随后由专车转至深圳隔离。12日，广州市疾控中心通报患者新冠病毒核酸检测阳性，当日深圳市疾控中心复核结果为阳性。13日，经专家会诊，确诊为新冠肺炎。目前患者已转到深圳市第三人民医院隔离治疗。初步判定，密接者为同乘航班的部分旅客，已通报广州市疾控部门请求协查。",
    "bk": "",
    "xb": "男",
    "rysj": "",
    "lssj": "2020/4/11",
    "fbingsj": "",
    "fbrq": "4月13日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "37",
    "blh": "458",
    "nationality&native":["中国",""],
    "treatment_hospital":"深圳市第三人民医院",
    "reason": '境外返回',
    "detailReason": '境外返回',
    "origin": '柬埔寨',
    "detailOrigin":'柬埔寨',
    "track": [{
        "from": "金边",
        "to": "深圳",
        "time": "2020/4/11",
        "tran": "专车",
    }],
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "巴西返回",
    "bzzzytjd": "中国籍，从巴西出差回国。3月21日，从巴西圣保罗乘TK194航班抵达土耳其伊斯坦布尔后转乘TK79航班前往中国香港。24日，从香港乘9C8922航班飞往上海，经上海浦东国际机场入境。25日，从上海乘CA1893航班抵达深圳后，由专车送往隔离。26日，因出差同事确诊新冠肺炎，患者转为密切接触者。4月3日，患者出现发热、咳嗽，体温38℃，随后由120救护车送医，胸部CT显示右上肺感染性病变。入院期间，多次新冠病毒核酸检测，结果均为阴性。12日，深圳市疾控中心对痰样本检测，结果为新冠病毒核酸阳性。13日，经专家会诊，确诊为新冠肺炎。目前患者已转到深圳市第三人民医院隔离治疗。初步判定，中国内地无密接者。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/4/3",
    "lssj": "2020/3/25",
    "fbingsj": "2020/4/3",
    "fbrq": "4月13日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "34",
    "blh": "457",
    "nationality&native":["中国",""],
    "track": [{
        "from": "圣保罗",
        "to": "伊斯坦布尔",
        "time": "2020/3/21",
        "tran": "TK194航班",
    }, {
        "from": "伊斯坦布尔",
        "to": "香港",
        "time": "2020/3/21",
        "tran": "TK79航班",
    }, {
        "from": "香港",
        "to": "上海",
        "time": "2020/3/24",
        "tran": "9C8922航班",
    }, {
        "from": "上海",
        "to": "深圳",
        "time": "2020/3/25",
        "tran": "CA1893航班",
    }],
    "treatment_hospital":"深圳市第三人民医院",
    "reason": '境外返回',
    "detailReason": '出差',
    "origin": '巴西',
    "detailOrigin": '圣保罗',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "美国返回",
    "bzzzytjd": "中国籍，从美国留学回国。4月3日从美国纽约乘KL646航班飞往荷兰阿姆斯特丹，后转乘CZ308航班飞往中国广州。4日，经广州白云机场入境，入境健康申报无异常，由专车送往深圳隔离。6日，广州海关新冠肺炎病毒核酸初筛阳性，当天深圳市疾控中心复核为阳性。7日，经专家会诊，确诊为新冠肺炎。目前患者已转到深圳市第三人民医院隔离治疗。初步判定，中国内地无密接者。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/4/7",
    "lssj": "",
    "fbingsj": "",
    "fbrq": "4月7日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "17",
    "blh": "456",
    "nationality&native":["中国",""],
    "track": [{
        "from": "纽约",
        "to": "阿姆斯特丹",
        "time": "2020/4/3",
        "tran": "KL646航班",
    }, {
        "from": "阿姆斯特丹",
        "to": "广州",
        "time": "2020/4/4",
        "tran": "CZ308航班",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/4/4",
        "tran": "专车",
    }],
    "treatment_hospital":"深圳市第三人民医院",
    "reason": '境外返回',
    "detailReason": '留学',
    "origin": '美国',
    "detailOrigin": '纽约',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "美国返回",
    "bzzzytjd": "中国籍，从美国留学回国。3月27日从美国旧金山乘CZ658航班飞往中国广州，29日，经广州白云机场入境，入境体温36.7℃，因申报有美国旅居史，海关进行新冠肺炎病毒核酸检测，初筛阴性，随后专车送往深圳隔离。4月2日患者出现发热，最高体温37.7℃，伴有咽干、咽痛、轻微咳嗽、乏力，随后由120救护车送医。3日，患者新冠肺炎病毒核酸检测阳性，当天深圳市疾控中心复核为阳性。4日，经专家会诊，确诊为新冠肺炎。患者已转到深圳市第三人民医院隔离治疗。初步判定，中国内地无密接者。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/4/2",
    "lssj": "2020/3/29",
    "fbingsj": "2020/4/2",
    "fbrq": "4月4日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "22",
    "blh": "454",
    "nationality&native":["中国",""],
    "track": [{
        "from": "旧金山",
        "to": "广州",
        "time": "2020/3/27",
        "tran": "CZ658航班",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/3/29",
        "tran": "专车",
    },],
    "treatment_hospital":"深圳市第三人民医院",
    "reason": '境外返回',
    "detailReason": '留学',
    "origin": '美国',
    "detailOrigin": '旧金山',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "英国返回",
    "bzzzytjd": "中国籍，由英国留学返回，3月17日，从英国曼切斯特乘坐飞机经瑞士苏黎世（航班号LX381）转日本东京（航班号LX160）前往中国广州（航班号NH933）。19日，经广州白云机场入境，入境健康申报无异常，后由专车送至深圳隔离。4月2日，新冠肺炎病毒核酸初筛阳性，患者自述当天出现轻微咽痛、咳嗽。3日，深圳市疾控中心复核为阳性，经专家会诊，确诊为新冠肺炎。患者已转到深圳市第三人民医院隔离治疗。初步判定，中国内地无密接者。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/4/3",
    "lssj": "",
    "fbingsj": "2020/4/2",
    "fbrq": "4月3日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "22",
    "blh": "453",
    "nationality&native":["中国",""],
    "track": [{
        "from": "曼切斯特",
        "to": "苏黎世",
        "time": "2020/3/17",
        "tran": "LX381航班",
    }, {
        "from": "苏黎世",
        "to": "东京",
        "time": "2020/3/17",
        "tran": "LX160航班",
    }, {
        "from": "东京",
        "to": "广州",
        "time": "2020/3/17",
        "tran": "NH933航班",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/3/19",
        "tran": "专车",
    }],
    "treatment_hospital":"深圳市第三人民医院",
    "reason": '境外返回',
    "detailReason": '留学',
    "origin": '英国',
    "detailOrigin": '曼切斯特',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "俄罗斯返回",
    "bzzzytjd": "中国籍，从俄罗斯探亲回国。3月17日从俄罗斯莫斯科乘坐SU220航班飞往中国广州。18日经广州白云机场入境，入境时红外线体温37.3℃，水银温度计复测体温36.5℃，后由专车送往深圳隔离，当天新冠病毒核酸检测阴性。31日患者出现咽喉不适，偶尔干咳。4月1日，新冠病毒核酸检测可疑阳性，当天深圳市疾控中心复核为阳性。2日经专家会诊，确诊为新冠肺炎。",
    "bk": "",
    "xb": "女",
    "rysj": "",
    "lssj": "",
    "fbingsj": "2020/3/31",
    "fbrq": "4月2日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "35",
    "blh": "452",
    "nationality&native":["中国",""],
    "track": [{
        "from": "莫斯科",
        "to": "广州",
        "time": "2020/3/17",
        "tran": "SU220航班",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/3/18",
        "tran": "专车",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '探亲',
    "origin": '俄罗斯',
    "detailOrigin": '莫斯科',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾前往美国，3月7日返回英国，3月15日英国返回中国",
    "bzzzytjd": "中国籍，从英国留学返回。患者自述近期曾前往美国，3月7日返回英国，11日起出现咳嗽、流涕等症状，但未就诊。15日，从英国伦敦乘坐CX254航班飞往中国香港。16日，抵达香港后经深圳湾口岸入境，入境时自主申报有咳嗽症状。17日，由120负压救护车送医，当天新冠病毒核酸初筛阴性，随后由专车送往隔离观察。29日，新冠病毒核酸再次检测结果为可疑阳性。30日，深圳市疾控中心复核为阳性，经专家会诊，确诊为新冠肺炎。",
    "bk": "",
    "xb": "女",
    "rysj": "2020/3/30",
    "lssj": "2020/3/16",
    "fbingsj": "2020/3/11",
    "fbrq": "3月30日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "21",
    "blh": "450",
    "nationality&native":["中国",""],
    "track": [{
        "from": "伦敦",
        "to": "香港",
        "time": "2020/3/15",
        "tran": "CX254航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/16",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '留学',
    "origin": '英国',
    "detailOrigin": '伦敦',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "美国返回",
    "bzzzytjd": "中国籍，从美国留学返回。3月25日从美国旧金山乘坐CZ658航班飞往中国广州，27日经广州白云机场入境，自述3月15日在美国出现头疼等症状，入境时体温正常，健康申报有咳嗽、咳痰、轻微流涕等症状。海关采样后，由专车送往隔离观察。28日，新型冠状病毒核酸初筛阳性。29日，深圳市疾控中心复核亦为阳性。经专家会诊，确诊为新冠病毒肺炎。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/29",
    "lssj": "",
    "fbingsj": "2020/3/15",
    "fbrq": "3月29日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "18",
    "blh": "449",
    "nationality&native":["中国",""],
    "track": [{
        "from": "旧金山",
        "to": "广州",
        "time": "2020/3/25",
        "tran": "CZ658航班",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/3/27",
        "tran": "专车",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '留学',
    "origin": '美国',
    "detailOrigin": '旧金山',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "美国返回",
    "bzzzytjd": "中国籍，从美国留学返回。3月18日，从美国华盛顿乘坐航班UA719飞往洛杉矶，在洛杉矶转乘航班CZ328前往中国广州。20日经广州白云机场入境，随后由专车接回深圳隔离观察。25日，患者出现不适症状。26日，由120救护车送医，当日医院检测阴性。28日，新型冠状病毒核酸初筛阳性，当天深圳市疾控中心复核亦为阳性。29日，经专家会诊，确诊为新冠病毒肺炎。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/26",
    "lssj": "2020/3/20",
    "fbingsj": "2020/3/25",
    "fbrq": "3月29日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "19",
    "blh": "448",
    "nationality&native":["中国",""],
    "track": [{
        "from": "华盛顿",
        "to": "洛杉矶",
        "time": "2020/3/18",
        "tran": "UA719航班",
    }, {
        "from": "洛杉矶",
        "to": "广州",
        "time": "2020/3/18",
        "tran": "CZ328航班",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/3/20",
        "tran": "专车",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '留学',
    "origin": '美国',
    "detailOrigin": '华盛顿',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "英国返回",
    "bzzzytjd": "中国籍，从英国留学返回。3月21日从英国伯明翰乘EK038航班飞往阿联酋迪拜，22日从迪拜乘EK380航班飞往中国香港，23日从香港乘HX238航班飞往上海，经虹桥机场入境，入境时自行申报一个月内有咳嗽症状，遂由当地安排救护车转运至医院留观。24日新冠病毒核酸初筛阴性。25日从上海乘CZ3552航班飞抵深圳，由专车送往隔离观察。27日患者出现发热、头痛、咳嗽加剧等症状，由120救护车送医。28日新型冠状病毒核酸检测阳性，深圳市疾控中心复核亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/27",
    "lssj": "2020/3/25",
    "fbingsj": "",
    "fbrq": "3月28日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "20",
    "blh": "447",
    "nationality&native":["中国",""],
    "track": [{
        "from": "伯明翰",
        "to": "迪拜",
        "time": "2020/3/21",
        "tran": "EK038航班",
    }, {
        "from": "迪拜",
        "to": "香港",
        "time": "2020/3/22",
        "tran": "EK380航班",
    }, {
        "from": "香港",
        "to": "上海",
        "time": "2020/3/23",
        "tran": "HX238航班",
    }, {
        "from": "上海",
        "to": "深圳",
        "time": "2020/3/25",
        "tran": "CZ3552航班",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '留学',
    "origin": '英国',
    "detailOrigin": '伯明翰',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "美国返回",
    "bzzzytjd": "美国籍，由美国返回深圳工作。3月21日从美国纽约乘坐BR0031航班飞往中国台北，22日从台北乘坐CA196航班飞往上海，经浦东机场入境，入境体温36.4℃。23日从上海乘坐CA1893航班抵达深圳后，由专车送往隔离观察。26日新冠病毒核酸初筛阳性，当天深圳市疾控中心复核亦为阳性。27日经专家会诊，临床诊断为新冠病毒肺炎。",
    "bk": "",
    "xb": "女",
    "rysj": "2020/3/27",
    "lssj": "2020/3/23",
    "fbingsj": "",
    "fbrq": "3月27日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "51",
    "blh": "446",
    "nationality&native":["中国",""],
    "track": [{
        "from": "纽约",
        "to": "台北",
        "time": "2020/3/21",
        "tran": "BR0031航班",
    }, {
        "from": "台北",
        "to": "上海",
        "time": "2020/3/22",
        "tran": "CA196航班",
    }, {
        "from": "上海",
        "to": "深圳",
        "time": "2020/3/23",
        "tran": "CA1893航班",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '探亲',
    "origin": '美国',
    "detailOrigin": '纽约',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "巴西返回",
    "bzzzytjd": "中国籍，由巴西返回。3月21日从巴西圣保罗乘坐TK194航班飞往土耳其伊斯坦布尔，23日从土耳其伊斯坦布尔乘坐TK070航班飞往中国香港，24日从香港乘坐9C8922航班飞往上海，经浦东机场入境，入境时体温正常。25日从上海乘坐航班CA1893抵达深圳后，由专车送往隔离观察。26日患者自感发热，水银温度计自测体温37.7℃，随后由120救护车送医，当天新冠病毒核酸初筛阳性，深圳市疾控中心复核亦为阳性。27日经专家会诊，临床诊断为新冠病毒肺炎。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/26",
    "lssj": "2020/3/25",
    "fbingsj": "2020/3/26",
    "fbrq": "3月27日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "32",
    "blh": "445",
    "nationality&native":["中国",""],
    "track": [{
        "from": "圣保罗",
        "to": "伊斯坦布尔",
        "time": "2020/3/21",
        "tran": "TK194航班",
    }, {
        "from": "伊斯坦布尔",
        "to": "香港",
        "time": "2020/3/23",
        "tran": "TK070航班",
    }, {
        "from": "香港",
        "to": "上海",
        "time": "2020/3/24",
        "tran": "9C8922航班",
    }, {
        "from": "上海",
        "to": "深圳",
        "time": "2020/3/25",
        "tran": "CA1893航班",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '巴西',
    "detailOrigin": '圣保罗',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "美国返回",
    "bzzzytjd": "中国籍，美国留学生返回深圳。3月17日从美国纽约乘坐CX845航班飞往中国香港，18日抵达香港后经深圳湾口岸入境，入境体温36.2℃，无不适症状，随后专车送往集中隔离观察。24日患者出现发热、咽痛、轻微流鼻涕症状，25日由120救护车送医，当天新冠病毒核酸检测可疑阳性。26日新冠病毒核酸检测阳性，深圳市疾控中心复核亦为阳性。",
    "bk": "",
    "xb": "女",
    "rysj": "2020/3/25",
    "lssj": "2020/3/18",
    "fbingsj": "2020/3/24",
    "fbrq": "3月26日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "20",
    "blh": "444",
    "nationality&native":["中国",""],
    "track": [{
        "from": "纽约",
        "to": "香港",
        "time": "2020/3/17",
        "tran": "CX845航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/18",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '留学',
    "origin": '美国',
    "detailOrigin": '纽约',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "法国返回",
    "bzzzytjd": "法国籍，在深圳工作。3月1日从法国巴黎乘坐AF188航班飞往中国香港，2日经深圳湾口岸入境，入境体温正常，健康申报无异常。11日，身体出现轻微不适。17日，14天隔离期结束。23日，到香港大学深圳医院就诊，肺部CT示双肺尖胸膜下见少许纤维条索影。24日新冠病毒核酸检测阳性，25日，深圳市疾控中心复核亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/25",
    "lssj": "2020/3/2",
    "fbingsj": "2020/3/11",
    "fbrq": "3月25日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "34",
    "blh": "443",
    "nationality&native":["法国",""],
    "track": [{
        "from": "巴黎",
        "to": "香港",
        "time": "2020/3/1",
        "tran": "AF188航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/2",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"香港大学深圳医院",
    "reason": '境外返回',
    "detailReason": '探亲',
    "origin": '法国',
    "detailOrigin": '巴黎',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "美国返回",
    "bzzzytjd": "中国籍，美国留学生返回深圳。3月22日从美国纽约乘坐CZ300航班飞往中国广州，23日经广州白云机场口岸入境，入境体温正常，随后乘专车隔离观察。24日新冠病毒核酸检测阳性，25日，深圳市疾控中心复核亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/25",
    "lssj": "2020/3/23",
    "fbingsj": "",
    "fbrq": "3月25日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "22",
    "blh": "442",
    "nationality&native":["中国",""],
    "track": [{
        "from": "纽约",
        "to": "广州",
        "time": "2020/3/22",
        "tran": "CZ300航班",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/3/23",
        "tran": "专车",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '留学',
    "origin": '美国',
    "detailOrigin": '纽约',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "英国返回",
    "bzzzytjd": "在深圳工作，巴西籍，由英国返回。3月21日从英国伦敦乘坐SQ305航班飞往新加坡，22日从新加坡乘坐CZ3040航班飞往中国广州，当晚经广州白云机场入境，入境体温36.6℃。23日凌晨由专车送往深圳集中隔离观察，24日新冠病毒核酸初筛阳性，当天深圳市疾控中心复核亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/24",
    "lssj": "2020/3/23",
    "fbingsj": "",
    "fbrq": "3月24日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "31",
    "blh": "441",
    "nationality&native":["巴西",""],
    "track": [{
        "from": "伦敦",
        "to": "新加坡",
        "time": "2020/3/21",
        "tran": "SQ305航班",
    }, {
        "from": "新加坡",
        "to": "广州",
        "time": "2020/3/22",
        "tran": "CZ3040航班",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/3/23",
        "tran": "专车",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '英国',
    "detailOrigin": '伦敦',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "美国返回",
    "bzzzytjd": "中国籍，由美国返回。3月16日从美国洛杉矶搭乘飞机返回中国香港，抵达后返回香港住所。17日-22日在香港工作。22日经深圳湾口岸入境，入境体温37.4℃，复测体温37.8℃，因申报有美国旅居史，曾有肌肉酸痛症状，海关对其采样检测后由专车送往隔离观察，当天新冠病毒核酸初筛阳性，23日深圳市疾控中心复核亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/23",
    "lssj": "2020/3/22",
    "fbingsj": "",
    "fbrq": "3月23日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "32",
    "blh": "440",
    "nationality&native":["中国",""],
    "track": [{
        "from": "洛杉矶",
        "to": "香港",
        "time": "2020/3/16",
        "tran": "不详航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/22",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '美国',
    "detailOrigin": '洛杉矶',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "西班牙返回",
    "bzzzytjd": "中国籍，由西班牙返回。3月10日从西班牙马德里乘坐CX320航班飞往中国香港，11日抵达香港后从深圳湾口岸入境，入境时腋温37.3℃，因申报有西班牙旅居史，入境后由专车送往隔离观察，当天新冠病毒核酸初筛阳性，CT诊断结果为双下肺炎症。其后经深圳市疾控中心多次复核检测，21日检出新冠病毒核酸阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/21",
    "lssj": "2020/3/11",
    "fbingsj": "",
    "fbrq": "3月21日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "19",
    "blh": "439",
    "nationality&native":["中国",""],
    "track": [{
        "from": "马德里",
        "to": "香港",
        "time": "2020/3/10",
        "tran": "CX320航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/11",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '西班牙',
    "detailOrigin": '马德里',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "泰国返回",
    "bzzzytjd": "中国籍，由泰国返回。3月19日从泰国曼谷乘坐TG668航班飞往中国广州，抵达广州后从白云机场入境，入境时体温36.3℃，因申报有泰国旅居史，入境后由专车送至深圳。20日凌晨抵达深圳后隔离观察，当天新冠病毒核酸初筛阳性。21日深圳市疾控中心复核亦为阳性。",
    "bk": "",
    "xb": "女",
    "rysj": "2020/3/21",
    "lssj": "2020/3/20",
    "fbingsj": "",
    "fbrq": "3月21日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "25",
    "blh": "438",
    "nationality&native":["中国",""],
    "track": [{
        "from": "曼谷",
        "to": "广州",
        "time": "2020/3/19",
        "tran": "TG668航班",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/3/20",
        "tran": "专车",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '泰国',
    "detailOrigin": '曼谷',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "英国返回",
    "bzzzytjd": "中国籍，由英国返回。3月16日从英国伦敦乘坐SQ321航班飞往新加坡， 18日从新加坡乘坐SQ856航班飞往中国香港，抵达香港后从深圳湾口岸入境，入境时体温36.5℃，因申报有英国旅居史，入境后由专车送往隔离观察。19日患者开始出现腹泻、发烧、头痛等症状，20日新冠病毒核酸检测阳性，21日深圳市疾控中心复核亦为阳性。",
    "bk": "",
    "xb": "女",
    "rysj": "2020/3/21",
    "lssj": "2020/3/18",
    "fbingsj": "2020/3/19",
    "fbrq": "3月21日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "23",
    "blh": "437",
    "nationality&native":["中国",""],
    "track": [{
        "from": "伦敦",
        "to": "新加坡",
        "time": "2020/3/16",
        "tran": "SQ321航班",
    }, {
        "from": "新加坡",
        "to": "香港",
        "time": "2020/3/18",
        "tran": "SQ856航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/18",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '英国',
    "detailOrigin": '伦敦',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "英国返回",
    "bzzzytjd": "中国籍，由英国返回。3月17日从英国伦敦乘坐SQ317航班飞往新加坡，18日乘坐SQ856航班从新加坡飞往中国香港，抵达香港后从深圳湾口岸入境，因申报有英国居住史，自述曾发热，由专车送往隔离观察。19日，新冠病毒核酸初筛阳性，20日深圳市疾控中心复核亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/20",
    "lssj": "2020/3/18",
    "fbingsj": "",
    "fbrq": "3月20日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "20",
    "blh": "436",
    "nationality&native":["中国",""],
    "track": [{
        "from": "伦敦",
        "to": "新加坡",
        "time": "2020/3/17",
        "tran": "SQ317航班",
    }, {
        "from": "新加坡",
        "to": "香港",
        "time": "2020/3/18",
        "tran": "SQ856航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/18",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '英国',
    "detailOrigin": '伦敦',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "英国返回",
    "bzzzytjd": "中国籍，由英国返回。3月17日从英国伦敦乘EK004航班飞往阿联酋迪拜，18日乘EK0380航班从阿联酋迪拜飞往中国香港。抵达香港后从深圳湾口岸入境，因申报有英国居住史，19日凌晨由专车送往隔离观察。20日新冠病毒核酸初筛阳性，当天深圳市疾控中心复核亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/20",
    "lssj": "2020/3/18",
    "fbingsj": "",
    "fbrq": "3月20日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "26",
    "blh": "435",
    "nationality&native":["中国",""],
    "track": [{
        "from": "伦敦",
        "to": "迪拜",
        "time": "2020/3/17",
        "tran": "EK004航班",
    }, {
        "from": "迪拜",
        "to": "香港",
        "time": "2020/3/18",
        "tran": "EK0380航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/18",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '英国',
    "detailOrigin": '伦敦',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "英国返回",
    "bzzzytjd": "中国籍，由英国返回。3月16日从英国伦敦乘坐BA011航班飞往新加坡，17日到达新加坡，18日乘坐CX658航班从新加坡飞往中国香港，抵达香港后从深圳湾口岸入境，入境自动测温37.5℃，水银复测37.1℃，海关采样后由专车送往隔离观察。19日，新冠病毒核酸初筛阳性，20日深圳市疾控中心复核亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/20",
    "lssj": "2020/3/18",
    "fbingsj": "",
    "fbrq": "3月20日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "19",
    "blh": "434",
    "nationality&native":["中国",""],
    "track": [{
        "from": "伦敦",
        "to": "新加坡",
        "time": "2020/3/16",
        "tran": "BA011航班",
    }, {
        "from": "新加坡",
        "to": "香港",
        "time": "2020/3/18",
        "tran": "CX658航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/18",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '英国',
    "detailOrigin": '伦敦',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "菲律宾返回",
    "bzzzytjd": "中国籍，由菲律宾返回。3月18日从菲律宾马尼拉乘坐CX930航班飞往中国香港。抵达香港后从深圳湾口岸入境，入境体温37.6℃，因申报有菲律宾居住史，曾出现寒战、乏力、腹泻等症状，海关采样后由专车送往隔离观察。19日，新冠病毒核酸初筛阳性，20日深圳市疾控中心复核亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/20",
    "lssj": "2020/3/18",
    "fbingsj": "",
    "fbrq": "3月20日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "42",
    "blh": "433",
    "nationality&native":["中国",""],
    "track": [{
        "from": "马尼拉",
        "to": "香港",
        "time": "2020/3/18",
        "tran": "CX930航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/18",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '菲律宾',
    "detailOrigin": '马尼拉',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "英国返回",
    "bzzzytjd": "中国籍，由英国返回。3月17日从伦敦乘坐EK004航班前往阿联酋迪拜后，转乘EK380航班前往中国香港。18日抵达香港后经深圳湾口岸入境，入境体温37.5℃，后由120救护车转至罗湖区人民医院春风分院。19日，采集咽拭子进行检测，结果为新冠病毒核酸初筛阳性，17时深圳市疾控中心完成复核，结果亦为阳性。",
    "bk": "",
    "xb": "女",
    "rysj": "2020/3/18",
    "lssj": "2020/3/18",
    "fbingsj": "",
    "fbrq": "3月19日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "20",
    "blh": "432",
    "nationality&native":["中国",""],
    "track": [{
        "from": "伦敦",
        "to": "迪拜",
        "time": "2020/3/17",
        "tran": "EK004航班",
    }, {
        "from": "迪拜",
        "to": "香港",
        "time": "2020/3/17",
        "tran": "EK380航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/18",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"罗湖区人民医院春风分院",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '英国',
    "detailOrigin": '伦敦',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "英国返回",
    "bzzzytjd": "中国籍，由英国返回。3月17日从英国乘EK006航班飞往迪拜，转乘EK380飞往中国香港，18日抵达香港后经深圳湾口岸入境，入境体温36.2℃。19日由专车送往隔离观察，随后采集咽拭子进行检测，结果为新冠病毒核酸初筛阳性。19日20时，深圳市疾控中心完成复核，结果亦为阳性。",
    "bk": "",
    "xb": "女",
    "rysj": "2020/3/19",
    "lssj": "2020/3/18",
    "fbingsj": "",
    "fbrq": "3月19日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "23",
    "blh": "431",
    "nationality&native":["中国",""],
    "track": [{
        "from": "伦敦",
        "to": "迪拜",
        "time": "2020/3/17",
        "tran": "EK004航班",
    }, {
        "from": "迪拜",
        "to": "香港",
        "time": "2020/3/17",
        "tran": "EK380航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/18",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '英国',
    "detailOrigin": '伦敦',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "美国返回",
    "bzzzytjd": "中国籍，由美国返回。3月16日从美国纳什维尔乘坐AA3203航班飞往芝加哥，随后乘坐CX807航班飞往中国香港。17日抵达香港后经深圳湾口岸入境，入境体温36.4℃，入境后由专车送往隔离观察，18日，隔离点驻点医生对其进行采样，19日，新冠病毒核酸初筛阳性。当天10时，深圳市疾控中心完成复核，结果亦为阳性",
    "bk": "",
    "xb": "女",
    "rysj": "2020/3/19",
    "lssj": "2020/3/17",
    "fbingsj": "",
    "fbrq": "3月19日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "19",
    "blh": "430",
    "nationality&native":["中国",""],
    "track": [{
        "from": "纳什维尔",
        "to": "芝加哥",
        "time": "2020/3/16",
        "tran": "AA3203航班",
    }, {
        "from": "芝加哥",
        "to": "香港",
        "time": "2020/3/16",
        "tran": "CX807航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/17",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '美国',
    "detailOrigin": '那什维尔',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "法国返回",
    "bzzzytjd": "法国籍，由法国返回。3月16日从法国巴黎乘坐CZ348航班回国，17日抵达广州，入境体温36.4℃，入境后由专车送往隔离观察。18日患者自述有头痛、轻微咳嗽症状，随后采集咽拭子进行检测，结果为新冠病毒核酸初筛阳性。19日1时，深圳市疾控中心完成复核，结果亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/19",
    "lssj": "",
    "fbingsj": "2020/3/18",
    "fbrq": "3月19日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "37",
    "blh": "429",
    "nationality&native":["法国",""],
    "track": [{
        "from": "巴黎",
        "to": "广州",
        "time": "2020/3/16",
        "tran": "CZ348航班",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/3/17",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '法国',
    "detailOrigin": '巴黎',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "法国旅居",
    "bzzzytjd": "中国籍，由法国返回。3月14日从法国巴黎乘坐LH104航班抵达德国法兰克福后，转乘LH796航班，于15日抵达中国香港。17日，患者经深圳湾口岸入境，入境体温36.5 ℃，因申报有法国旅居史，有咳嗽、乏力等症状，海关将其隔离观察并采集咽拭子。18日，新冠病毒核酸初筛阳性。19日2时，深圳市疾控中心完成复核，结果亦为阳性。",
    "bk": "",
    "xb": "女",
    "rysj": "2020/3/19",
    "lssj": "2020/3/17",
    "fbingsj": "",
    "fbrq": "3月19日",
    "jzd": "",
    "fbusj": "24时",
    "nl": "36",
    "blh": "428",
    "nationality&native":["中国",""],
    "track": [{
        "from": "巴黎",
        "to": "法兰克福",
        "time": "2020/3/14",
        "tran": "LH104航班",
    }, {
        "from": "法兰克福",
        "to": "香港",
        "time": "2020/3/14",
        "tran": "LH796航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/17",
        "tran": "深圳湾口岸",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '旅游',
    "origin": '法国',
    "detailOrigin": '巴黎',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "英国留学",
    "bzzzytjd": "2020年3月16日上午，患者从伦敦希思罗机场乘坐SQ317航班前往新加坡樟宜机场；3月17日，患者在新加坡乘坐SQ856航班，前往香港；3月17日13时，患者抵达香港国际机场后，乘坐直通车转乘出租车前往深圳；3月17日15时，患者到达深圳湾口岸。入境时体温为36.4 ℃，自述有英国旅居史，自觉咳嗽、乏力等症状，海关部门将其留置于深圳湾口岸隔离观察室。3月17日22时，120救护车将其转送到华中科技大学协和深圳医院诊治。3月18日11时，华中科技大学协和深圳医院完成新型冠状病毒核酸检测，结果为阳性。3月18日19时，深圳市疾控中心完成复核，结果亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/17",
    "lssj": "2020/3/17",
    "fbingsj": "",
    "fbrq": "3月18日",
    "jzd": "广东省东莞市",
    "fbusj": "24时",
    "nl": "19",
    "blh": "427",
    "nationality&native":["中国",""],
    "track": [{
        "from": "伦敦",
        "to": "新加坡",
        "time": "2020/3/16",
        "tran": "SQ317航班",
    }, {
        "from": "新加坡",
        "to": "香港",
        "time": "2020/3/17",
        "tran": "SQ856航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/17",
        "tran": "出租车",
    }],
    "treatment_hospital":"华中科技大学协和深圳医院",
    "reason": '境外返回',
    "detailReason": '留学',
    "origin": '英国',
    "detailOrigin": '伦敦',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "英国留学",
    "bzzzytjd": "2020年3月15日，患者从伦敦希思罗机场乘坐AY1338航班到达芬兰赫尔辛基机场。3月16日0时，患者乘坐AY099航班前往香港。3月16日16时，患者抵达香港，后乘坐出租车前往深圳湾口岸，入境时戴双层口罩（内层医用口罩，外层N99口罩），体温为36.3℃。3月16日22时，患者被福田区专车送到集中隔离点入住。3月17日9时，驻点医生对患者采集咽拭子。3月17日20时，患者出现低热，腋温37.2℃。3月18日8时，驻点医生反馈，初筛结果为新冠病毒核酸阳性。3月18日8时，患者由120负压救护车转送深圳市第三人民医院隔离治疗。3月18日15时，深圳市疾控中心完成复核，结果亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/18",
    "lssj": "2020/3/16",
    "fbingsj": "2020/3/17",
    "fbrq": "3月18日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "22",
    "blh": "426",
    "nationality&native":["中国",""],
    "track": [{
        "from": "伦敦",
        "to": "赫尔辛基",
        "time": "2020/3/15",
        "tran": "AY1338航班",
    }, {
        "from": "赫尔辛基",
        "to": "香港",
        "time": "2020/3/16",
        "tran": "AY099航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/16",
        "tran": "出租车",
    }],
    "treatment_hospital":"深圳市第三人民医院",
    "reason": '境外返回',
    "detailReason": '留学',
    "origin": '英国',
    "detailOrigin": '伦敦',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "荷兰休假",
    "bzzzytjd": "2020年3月14日17:15，患者从荷兰阿姆斯特丹乘坐KL875航班前往泰国曼谷。3月15日18:35，患者从泰国曼谷乘坐CZ8324航班前往深圳，患者自述飞行期间除就餐外均佩戴口罩。3月15日23:00，患者抵达深圳机场入境。3月16日5:00，患者被罗湖区专车送至罗湖区党校采样，采样后专车送其回家，居家隔离。3月16日21:35，罗湖区人民医院完成咽拭子样品的检测，结果为新冠病毒核酸阳性。3月17日7:55，深圳市疾控中心完成复核，结果亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/17",
    "lssj": "2020/3/15",
    "fbingsj": "",
    "fbrq": "3月17日",
    "jzd": "深圳市罗湖区",
    "fbusj": "24时",
    "nl": "29",
    "blh": "425",
    "nationality&native":["中国",""],
    "track": [{
        "from": "阿姆斯特丹",
        "to": "曼谷",
        "time": "2020/3/14",
        "tran": "KL875航班",
    }, {
        "from": "曼谷",
        "to": "深圳",
        "time": "2020/3/15",
        "tran": "CZ8324航班",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '休假',
    "origin": '荷兰',
    "detailOrigin": '阿姆斯特丹',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "与疑似病例同乘一辆飞机",
    "bzzzytjd": "2020年3月14日17:48，患者从英国伦敦希思罗机场乘坐LH915航班前往德国法兰克福机场。3月14日22:37，患者从德国法兰克福乘坐LH796航班飞往中国香港，自觉乏力，自述同排有1名法国籍乘客有咳嗽症状。3月15日15:50，患者到达香港机场，17:06乘坐出租车前往深圳湾口岸。3月15日20:54，患者从深圳湾口岸入境，检测有发热（红外测温37.3℃，手持测温枪37.4℃，水银温度测温37.3℃）。3月16日5:00，深圳海关采集患者咽拭子、鼻拭子及血液样本后，通知120救护车将其转送到宝安区人民医院隔离留观。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/16",
    "lssj": "2020/3/15",
    "fbingsj": "2020/3/15",
    "fbrq": "3月17日",
    "jzd": "深圳市宝安区",
    "fbusj": "24时",
    "nl": "23",
    "blh": "424",
    "nationality&native":["中国",""],
    "track": [{
        "from": "伦敦",
        "to": "法兰克福",
        "time": "2020/3/14",
        "tran": "LH915航班",
    }, {
        "from": "法兰克福",
        "to": "香港",
        "time": "2020/3/14",
        "tran": "LH796航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/15",
        "tran": "出租车",
    }],
    "treatment_hospital":"宝安区人民医院",
    "reason": '境外返回',
    "detailReason": '密切接触',
    "origin": '英国',
    "detailOrigin": '伦敦',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "菲律宾马尼拉工作",
    "bzzzytjd": "2020年3月5日20:00，刘某自述开始发热。3月6日11:00，刘某自测体温达38.4℃，自行服药，3月10日后，症状消失。3月13日，刘某再次发热， 7:00自测体温为36.8℃。3月14日12:25，刘某乘坐KA5930航班从菲律宾马尼拉返回中国，14:50到达香港机场后，乘坐出租车前往深圳湾口岸。3月14日16:00，刘某从深圳湾口岸入境，体温正常（36.4℃），由于其填写的健康申报卡显示有菲律宾工作史，出现咳嗽、咳痰等症状，深圳海关将其留观，并采集鼻咽拭子和血液样本。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/15",
    "lssj": "2020/3/14",
    "fbingsj": "2020/3/5",
    "fbrq": "3月15日",
    "jzd": "深圳市龙岗区",
    "fbusj": "24时",
    "nl": "31",
    "blh": "423",
    "nationality&native":["中国",""],
    "track": [{
        "from": "马尼拉",
        "to": "法兰克福",
        "time": "2020/3/14",
        "tran": "KA5930航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/14",
        "tran": "出租车",
    }],
    "track_trans":["KA5930航班","出租车"],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '工作',
    "origin": '菲律宾',
    "detailOrigin": '马尼拉',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "瑞士学习",
    "bzzzytjd": "患者于2020年1月4日，从深圳经香港到瑞士。3月11日，邓某开始出现喉咙痛、咳嗽、咳黄痰等症状，无发热。3月13日11:10，邓某从瑞士苏黎世乘坐CX382航班返回中国。3月14日6:30，抵达香港国际机场，随后乘坐商务车前往深圳湾口岸，回国全程均佩戴口罩。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/14",
    "lssj": "2020/3/14",
    "fbingsj": "2020/3/11",
    "fbrq": "3月15日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "13",
    "blh": "422",
    "nationality&native":["中国",""],
    "track": [{
        "from": "苏黎世",
        "to": "香港",
        "time": "2020/3/13",
        "tran": "CX382航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/14",
        "tran": "商务车",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '学习',
    "origin": '瑞士',
    "detailOrigin": '苏黎世',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "菲律宾马尼拉工作",
    "bzzzytjd": "患者于2019年7月起从中国前往菲律宾马尼拉工作，此前居住于深圳南山区。3月13日19:05从马尼拉乘坐CX902航班返回中国，22:20到达香港国际机场，随后乘坐香港的士前往深圳湾口岸，期间均佩戴口罩。3月13日23:30，患者从深圳湾口岸入境，体温正常（腋温36.5℃），由于其填写的健康申报卡显示有菲律宾工作史、曾出现咽痛等症状，深圳海关为患者采集鼻咽拭子和血液样本，并将其隔离留观。3月14日6:30，患者由120救护车送至华中科技大学协和深圳医院感染科收治观察。医院CT检查显示双肺感染。3月14日12:00，华中科技大学协和深圳医院对患者的咽拭子样本完成初筛，结果为新冠病毒核酸阳性。3月14日20:00，深圳市疾控中心完成复核，结果亦为阳性。",
    "bk": "",
    "xb": "男",
    "rysj": "2020/3/14",
    "lssj": "2020/3/13",
    "fbingsj": "2020/3/9",
    "fbrq": "3月14日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "52",
    "blh": "421",
    "nationality&native":["中国","深圳南山区"],
    "track": [{
        "from": "马尼拉",
        "to": "香港",
        "time": "2020/3/13",
        "tran": "CX902航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/13",
        "tran": "出租车",
    }],
    "treatment_hospital":"华中科技大学协和深圳医院",
    "reason": '境外返回',
    "detailReason": '工作',
    "origin": '菲律宾',
    "detailOrigin": '马尼拉',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "法国旅行",
    "bzzzytjd": "患者于2020年2月7日因公出差，从深圳前往香港机场，乘坐飞机抵达法国巴黎（航班号CX261），期间一直停留在法国巴黎。他自述，在法国期间，有一名与其共事的法国籍人士有发热症状；2020年3月9日从法国巴黎乘坐飞机返回香港（航班号CX260），3月10日清晨到达香港机场后，直接乘坐香港的士（车牌号UF1749）到达深圳湾口岸；",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/3/10",
    "lssj": "2020/3/10",
    "fbingsj": "2020/3/2",
    "fbrq": "3月11日",
    "jzd": "深圳市宝安区",
    "fbusj": "24时",
    "nl": "25",
    "blh": "420",
    "nationality&native":["中国",""],
    "track": [{
        "from": "巴黎",
        "to": "香港",
        "time": "2020/3/9",
        "tran": "CX261航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/3/10",
        "tran": "出租车",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '旅游',
    "origin": '法国',
    "detailOrigin": '巴黎',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "西班牙旅游",
    "bzzzytjd": "2020年1月10日，前往西班牙旅游。3月1日10时许，离开西班牙回国（航班号EY0050），经阿联酋阿布扎比转机（航班号EY0888），于2日8时50分抵达北京首都机场T3航站楼，当天14时25分乘飞机返回深圳（航班号ZH9104），抵深后由其儿子驾车接回家。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/3/4",
    "lssj": "2020/3/2",
    "fbingsj": "2020/3/3",
    "fbrq": "3月6日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "70",
    "blh": "419",
    "nationality&native":["中国",""],
    "track": [{
        "from": "巴塞罗那",
        "to": "阿布扎比",
        "time": "2020/3/1",
        "tran": "EY0050航班",
    }, {
        "from": "阿布扎比",
        "to": "北京",
        "time": "2020/3/2",
        "tran": "EY0888航班",
    }, {
        "from": "北京",
        "to": "深圳",
        "time": "2020/3/2",
        "tran": "ZH9104航班",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '旅游',
    "origin": '西班牙',
    "detailOrigin": '西班牙',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "英国回国",
    "bzzzytjd": "2020年2月27日，孙某由英国伦敦飞往香港（航班号CX250），28日13：27抵达香港机场，15:30渡轮（船次3A109）从香港至深圳蛇口码头，在码头入境时体温无异常。随后，孙某打车回家。返程期间，孙某全程佩戴口罩。回家后，孙某自述没有外出。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/29",
    "lssj": "2020/2/28",
    "fbingsj": "2020/2/29",
    "fbrq": "3月1日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "35",
    "blh": "418",
    "nationality&native":["中国",""],
    "track": [{
        "from": "伦敦",
        "to": "香港",
        "time": "2020/2/27",
        "tran": "CX250航班",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/2/28",
        "tran": "3A109航船",
    }],
    "treatment_hospital":"",
    "reason": '境外返回',
    "detailReason": '未知',
    "origin": '英国',
    "detailOrigin": '伦敦',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "其家人接触过武汉亲属",
    "bzzzytjd": "患者于2020年1月23日前往四川成都过年，自诉其家人接触过武汉亲属，31日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/16",
    "lssj": "2020/1/31",
    "fbingsj": "2020/2/12",
    "fbrq": "2月21日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "23",
    "blh": "417",
    "nationality&native":["中国",""],
    "track": [{
        "from": "成都",
        "to": "深圳",
        "time": "2020/1/31",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '四川',
    "detailOrigin": '成都',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月19日自驾到湖北鄂州过年，21日前往黄冈探亲。2月12日出现胸口不适，14日自驾从鄂州返回深圳，并直接入住湖北返深人员集中隔离点，16日因新冠病毒核酸筛查阳性入院就诊",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/16",
    "lssj": "2020/2/14",
    "fbingsj": "2020/2/12",
    "fbrq": "2月17日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "44",
    "blh": "416",
    "nationality&native":["中国",""],
    "track": [{
        "from": "鄂州",
        "to": "深圳",
        "time": "2020/2/14",
        "tran": "私家车",
    }],
    "treatment_hospital":"", 
    "reason": '湖北停留',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin": '鄂州',
  },
  {
    "yqtblgx": "病例397父亲",
    "zwhsjqj": "2019/11/1——2020/1/20",
    "rbyy": "武汉探亲",
    "bzzzytjd": "患者于2019年11月1日前往湖北武汉探亲，2020年1月20日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/10",
    "lssj": "2020/1/20",
    "fbingsj": "2020/2/9",
    "fbrq": "2月16日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "69",
    "blh": "415",
    "nationality&native":["中国",""],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '探亲',
    "origin": '四川',
    "detailOrigin": '成都',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月6日自驾前往湖北宜昌探亲，25日自驾返回深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/27",
    "fbrq": "2月15日",
    "jzd": "深圳市龙岗区",
    "fbusj": "24时",
    "nl": "51",
    "blh": "414",
    "nationality&native":["中国",""],
    "track": [{
        "from": "宜昌",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin": '宜昌',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月19日随亲属自驾车从深圳出发，前往湖北赤壁。1月27日发病，30日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/7",
    "lssj": "2020/1/30",
    "fbingsj": "2020/1/27",
    "fbrq": "2月15日",
    "jzd": "深圳市宝安区",
    "fbusj": "24时",
    "nl": "53",
    "blh": "413",
    "nationality&native":["中国",""],
    "track": [{
        "from": "赤壁",
        "to": "深圳",
        "time": "2020/1/30",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '赤壁',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "武汉居住",
    "bzzzytjd": "患者常住于湖北武汉。1月23日从武汉到深圳过年。2月12日在家接触过有武汉旅居史的客人。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/14",
    "lssj": "2020/1/23",
    "fbingsj": "2020/2/14",
    "fbrq": "2月15日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "65",
    "blh": "412",
    "nationality&native":["中国",""],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "track_trans":[""],
    "treatment_hospital":"",
    "reason": '湖北居住',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin": '武汉',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月21日自驾车前往湖北孝感探亲，25日自驾返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/14",
    "lssj": "2020/1/25",
    "fbingsj": "2020/2/13",
    "fbrq": "2月15日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "44",
    "blh": "411",
    "nationality&native":["中国",""],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin": '孝感',
  },
  {
    "yqtblgx": "病例304岳母",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "患者常住于湖北咸宁。1月22日到深圳过年。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/12",
    "lssj": "2020/1/22",
    "fbingsj": "2020/2/12",
    "fbrq": "2月15日",
    "jzd": "湖北省咸宁市",
    "fbusj": "24时",
    "nl": "59",
    "blh": "410",
    "nationality&native":["中国",""],
    "track": [{
        "from": "咸宁",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '湖北居住',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin": '咸宁',
  },
  {
    "yqtblgx": "病例179儿媳",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月22日自驾车从深圳到湖北枝江，24日自驾车返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/14",
    "lssj": "2020/1/24",
    "fbingsj": "2020/2/14",
    "fbrq": "2月15日",
    "jzd": "深圳市宝安区",
    "fbusj": "24时",
    "nl": "33",
    "blh": "409",
    "nationality&native":["中国",""],
    "track": [{
        "from": "枝江",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '枝江'
  },
  {
    "yqtblgx": "病例171女儿",
    "zwhsjqj": "",
    "rbyy": "曾与新冠肺炎确诊病例接触",
    "bzzzytjd": "自述近期无湖北相关旅居史，接触过新冠肺炎确诊患者。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/14",
    "lssj": "",
    "fbingsj": "2020/1/30",
    "fbrq": "2月15日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "38",
    "blh": "408",
    "nationality&native":["中国",""],
    "track": [],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": ''
  },
  {
    "yqtblgx": "病例382儿媳",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月22日前往湖北黄石，24日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/9",
    "lssj": "2020/1/24",
    "fbingsj": "2020/2/9",
    "fbrq": "2月15日",
    "jzd": "深圳市龙岗区",
    "fbusj": "24时",
    "nl": "37",
    "blh": "407",
    "nationality&native":["中国",""],
    "track": [{
        "from": "黄石",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": ''
  },
  {
    "yqtblgx": "病例207母亲",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月20日自驾车前往湖北荆州，26日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/13",
    "lssj": "2020/1/26",
    "fbingsj": "2020/2/13",
    "fbrq": "2月14日",
    "jzd": "深圳市光明区",
    "fbusj": "24时",
    "nl": "32",
    "blh": "406",
    "nationality&native":["中国",""],
    "track": [{
        "from": "荆州",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '荆州'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾与新冠肺炎确诊病例接触",
    "bzzzytjd": "患者于2020年1月25日前往江西南昌，后搭乘私家车到九江，2月8日随亲属自驾返回深圳。在九江期间与新冠肺炎确诊病例有密切接触史。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/13",
    "lssj": "2020/2/8",
    "fbingsj": "2020/2/12",
    "fbrq": "2月14日",
    "jzd": "深圳市宝安区",
    "fbusj": "24时",
    "nl": "51",
    "blh": "405",
    "nationality&native":["中国",""],
    "track": [{
        "from": "南昌",
        "to": "九江",
        "time": "2020/1/25",
        "tran": "私家车",
    }, {
        "from": "九江",
        "to": "深圳",
        "time": "2020/2/8",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '密切接触',
    "origin": '江西',
    "detailOrigin": '九江'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾与新冠肺炎确诊病例接触",
    "bzzzytjd": "患者于2020年1月22日前往昆明参加团体游，自述期间接触过武汉参团人员中的新冠肺炎确诊病例；25日从西双版纳到昆明，后查询当日该航班上有新冠肺炎确诊病例。27日从昆明返回深圳，2月13日发病。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/14",
    "lssj": "2020/1/27",
    "fbingsj": "2020/2/13",
    "fbrq": "2月14日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "26",
    "blh": "404",
    "nationality&native":["中国",""],
    "track": [{
        "from": "昆明",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '旅游',
    "origin": '云南',
    "detailOrigin": '昆明'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾与武汉来深亲属接触",
    "bzzzytjd": "自述近期无湖北相关旅居史，1月19日以来接触过武汉来深亲属。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/12",
    "lssj": "",
    "fbingsj": "2020/2/11",
    "fbrq": "2月14日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "36",
    "blh": "403",
    "nationality&native":["中国",""],
    "track": [],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '探亲',
    "origin": '深圳',
    "detailOrigin": '深圳'
  },
  {
    "yqtblgx": "病例397母亲",
    "zwhsjqj": "2019/11/1——2019/11/9",
    "rbyy": "武汉探亲",
    "bzzzytjd": "患者于2019年11月1日与丈夫前往武汉探亲，9日独自返回深圳，丈夫于2020年1月20日乘火车返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/11",
    "lssj": "2019/11/9",
    "fbingsj": "2020/2/10",
    "fbrq": "2月14日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "69",
    "blh": "402",
    "nationality&native":["中国",""],
    "track": [],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '武汉'
  },
  {
    "yqtblgx": "病例396丈夫",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月21日自驾前往湖北天门，24日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/11",
    "lssj": "2020/1/24",
    "fbingsj": "2020/2/4",
    "fbrq": "2月14日",
    "jzd": "深圳市龙岗区",
    "fbusj": "24时",
    "nl": "57",
    "blh": "401",
    "nationality&native":["中国",""],
    "track": [{
        "from": "天门",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '天门'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "2020/1/17",
    "rbyy": "武汉停留",
    "bzzzytjd": "患者于2020年1月17日从武汉前往澳大利亚旅游，途径悉尼、墨尔本等地，26日经广州到达深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/9",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/27",
    "fbrq": "2月14日",
    "jzd": "湖北省汉川市",
    "fbusj": "12时",
    "nl": "53",
    "blh": "400",
    "nationality&native":["中国",""],
    "track": [{
        "from": "武汉",
        "to": "澳大利亚",
        "time": "2020/1/17",
        "tran": "",
    }, {
        "from": "澳大利亚",
        "to": "广州",
        "time": "2020/1/17",
        "tran": "",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin": '武汉'
  },
  {
    "yqtblgx": "病例372婆婆",
    "zwhsjqj": "",
    "rbyy": "曾与武汉来深亲属接触",
    "bzzzytjd": "自述近期无湖北相关旅居史，1月19日后与湖北武汉来深的亲属有接触史。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/7",
    "lssj": "",
    "fbingsj": "2020/1/29",
    "fbrq": "2月14日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "64",
    "blh": "399",
    "nationality&native":["中国",""],
    "track": [],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '探亲',
    "origin": '深圳',
    "detailOrigin": '深圳'
  },
  {
    "yqtblgx": "病例133哥哥",
    "zwhsjqj": "",
    "rbyy": "曾与新冠肺炎确诊病例接触",
    "bzzzytjd": "自述近期无湖北相关旅居史，有接触新冠肺炎确诊病人。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/1",
    "lssj": "",
    "fbingsj": "2020/2/1",
    "fbrq": "2月14日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "56",
    "blh": "398",
    "nationality&native":["中国",""],
    "track":[],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '密切接触',
    "origin": '深圳',
    "detailOrigin": '深圳'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾与武汉返深亲属密切接触",
    "bzzzytjd": "自述近期无湖北相关旅居史，1月22日后与湖北武汉返深亲属有密切接触史。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/10",
    "lssj": "",
    "fbingsj": "2020/2/10",
    "fbrq": "2月14日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "49",
    "blh": "397",
    "nationality&native":["中国",""],
    "track":[],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '探亲',
    "origin": '深圳',
    "detailOrigin": '深圳'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月21日自驾前往湖北天门，24日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/12",
    "lssj": "2020/1/24",
    "fbingsj": "2020/2/10",
    "fbrq": "2月14日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "54",
    "blh": "396",
    "nationality&native":["中国",""],
    "track": [{
        "from": "天门",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '天门'
  },
  {
    "yqtblgx": "病例235姐姐",
    "zwhsjqj": "",
    "rbyy": "曾与新冠肺炎确诊病例密切接触",
    "bzzzytjd": "患者与家中新冠肺炎确诊病例有密切接触史。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/11",
    "lssj": "",
    "fbingsj": "2020/2/7",
    "fbrq": "2月14日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "58",
    "blh": "395",
    "nationality&native":["中国",""],
    "track":[],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": '深圳'
  },
  {
    "yqtblgx": "病例335女儿",
    "zwhsjqj": "",
    "rbyy": "曾与湖北来深人员接触",
    "bzzzytjd": "自述近期无湖北相关旅居史，曾和湖北来深人员接触。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/12",
    "lssj": "",
    "fbingsj": "2020/2/10",
    "fbrq": "2月14日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "42",
    "blh": "394",
    "nationality&native":["中国",""],
    "track":[],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": '深圳'
  },
  {
    "yqtblgx": "病例304岳父",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "患者常住于湖北咸宁。1月22日从赤壁到深圳探亲。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/12",
    "lssj": "2020/1/22",
    "fbingsj": "2020/2/1",
    "fbrq": "2月14日",
    "jzd": "湖北省咸宁市",
    "fbusj": "12时",
    "nl": "59",
    "blh": "393",
    "nationality&native":["中国","湖北咸宁"],
    "track": [{
        "from": "赤壁",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '湖北居住',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin": '咸宁'
  },
  {
    "yqtblgx": "病例235侄子",
    "zwhsjqj": "",
    "rbyy": "曾与新冠肺炎确诊病例接触",
    "bzzzytjd": "患者与家中新冠肺炎确诊病例有密切接触史。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/11",
    "lssj": "",
    "fbingsj": "2020/2/11",
    "fbrq": "2月14日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "25",
    "blh": "392",
    "nationality&native":["中国",""],
    "track":[],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": '深圳'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月20日自驾到湖北随州，1月24日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/1/24",
    "fbingsj": "2020/2/2",
    "fbrq": "2月13日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "41",
    "blh": "391",
    "nationality&native":["中国",""],
    "track": [{
        "from": "随州",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '随州'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾与新冠肺炎确诊病例接触",
    "bzzzytjd": "患者于2020年1月20日自驾到江西新余，与老家新冠肺炎确诊病例有接触史，2月9日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/11",
    "lssj": "2020/2/9",
    "fbingsj": "2020/2/10",
    "fbrq": "2月13日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "34",
    "blh": "390",
    "nationality&native":["中国",""],
    "track": [{
        "from": "新余",
        "to": "深圳",
        "time": "2020/2/9",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '密切接触',
    "origin": '江西',
    "detailOrigin": '新余'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月10日前往广东中山，11日乘私家车到湖北咸宁，21日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/11",
    "lssj": "2020/1/21",
    "fbingsj": "2020/2/4",
    "fbrq": "2月13日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "52",
    "blh": "389",
    "nationality&native":["中国",""],
    "track": [{
        "from": "咸宁",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '',
    "origin": '广东',
    "detailOrigin": '中山'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/23",
    "rbyy": "武汉居住",
    "bzzzytjd": "患者常住于湖北武汉。于2020年1月23日来深圳过年。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/11",
    "lssj": "2020/1/23",
    "fbingsj": "2020/2/1",
    "fbrq": "2月13日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "53",
    "blh": "388",
    "nationality&native":["中国","湖北武汉"],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '湖北居住',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin": '武汉'
  },
  {
    "yqtblgx": "病例115妻子",
    "zwhsjqj": "——2020/1/17",
    "rbyy": "武汉居住",
    "bzzzytjd": "患者常住于湖北武汉。于2020年1月17日前往深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/11",
    "lssj": "2020/1/17",
    "fbingsj": "2020/2/8",
    "fbrq": "2月13日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "62",
    "blh": "387",
    "nationality&native":["中国","湖北武汉"],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/17",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '武汉'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北停留，曾与新冠肺炎确诊病例接触",
    "bzzzytjd": "患者于2020年1月15日自驾到湖北孝感探亲，25日自驾返回深圳，在湖北期间曾接触过新冠肺炎确诊病例。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/9",
    "lssj": "2020/1/25",
    "fbingsj": "2020/2/3",
    "fbrq": "2月11日",
    "jzd": "深圳市龙岗区",
    "fbusj": "24时",
    "nl": "31",
    "blh": "386",
    "nationality&native":["中国","湖北武汉"],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '密切接触',
    "origin": '湖北',
    "detailOrigin": '孝感'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "2020/1/13、2020/1/18-2020/1/19",
    "rbyy": "武汉停留",
    "bzzzytjd": "患者于2020年1月13日经武汉中转前往随州，18日从随州前往武汉游玩，次日返回随州，25日自驾返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/9",
    "lssj": "2020/1/25",
    "fbingsj": "2020/2/8",
    "fbrq": "2月11日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "28",
    "blh": "385",
    "nationality&native":["中国",""],
    "track": [{
        "from": "武汉",
        "to": "随州",
        "time": "2020/1/18",
        "tran": "私家车",
    }, {
        "from": "随州",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '旅游',
    "origin": '湖北',
    "detailOrigin": '武汉'
  },
  {
    "yqtblgx": "病例347儿子",
    "zwhsjqj": "",
    "rbyy": "曾与新冠肺炎确诊病例接触",
    "bzzzytjd": "患者于2020年1月23日到深圳探亲，期间有与新冠肺炎确诊病例接触史。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/8",
    "lssj": "2020/1/23",
    "fbingsj": "2020/2/6",
    "fbrq": "2月11日",
    "jzd": "广东省广州市",
    "fbusj": "24时",
    "nl": "22",
    "blh": "384",
    "nationality&native":["中国",""],
    "track": [{
        "from": "广州",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '武汉'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "经过湖北",
    "bzzzytjd": "患者于2020年1月20日自驾从深圳出发，途径湖北境内前往河南省信阳市探亲，1月28日自驾返回深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/9",
    "lssj": "2020/1/28",
    "fbingsj": "2020/2/2",
    "fbrq": "2月11日",
    "jzd": "深圳市龙岗区",
    "fbusj": "24时",
    "nl": "43",
    "blh": "383",
    "nationality&native":["中国",""],
    "track": [{
        "from": "信阳",
        "to": "深圳",
        "time": "2020/1/28",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin": ''
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "患者常住于湖北黄石。于2020年1月24日前往深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/9",
    "lssj": "2020/1/24",
    "fbingsj": "2020/2/9",
    "fbrq": "2月11日",
    "jzd": "湖北省黄石市",
    "fbusj": "24时",
    "nl": "69",
    "blh": "382",
    "nationality&native":["中国",""],
    "track": [{
        "from": "黄石",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '湖北居住',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '黄石'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾与新冠肺炎确诊病例接触",
    "bzzzytjd": "自述无湖北相关旅居史，1月24日-29日期间与新冠肺炎确诊病例有接触史。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/9",
    "lssj": "",
    "fbingsj": "2020/2/5",
    "fbrq": "2月11日",
    "jzd": "深圳市坪山区",
    "fbusj": "24时",
    "nl": "33",
    "blh": "381",
    "nationality&native":["中国",""],
    "track":[],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '密切接触',
    "origin": '深圳',
    "detailOrigin": ''
  },
  {
    "yqtblgx": "病例294妻子",
    "zwhsjqj": "",
    "rbyy": "曾与新冠肺炎确诊病例接触",
    "bzzzytjd": "患者于2020年1月18日自驾从深圳途经江西于都前往河南信阳，1月21日回南阳探亲，22日前往信阳，自述在信阳期间曾接触确诊病例，当晚返回南阳。1月25日自驾回深，26抵达。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/10",
    "lssj": "2020/1/26",
    "fbingsj": "2020/2/6",
    "fbrq": "2月11日",
    "jzd": "深圳市龙岗区",
    "fbusj": "24时",
    "nl": "40",
    "blh": "380",
    "nationality&native":["中国",""],
    "track": [{
        "from": "信阳",
        "to": "南阳",
        "time": "2020/1/22",
        "tran": "私家车",
    }, {
        "from": "南阳",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '河南',
    "detailOrigin": '南阳'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月18日自驾到湖北咸宁，25日自驾前往清远，26日驾车返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/8",
    "lssj": "2020/1/26",
    "fbingsj": "2020/2/8",
    "fbrq": "2月11日",
    "jzd": "深圳市宝安区",
    "fbusj": "24时",
    "nl": "28",
    "blh": "379",
    "nationality&native":["中国",""],
    "track": [{
        "from": "咸宁",
        "to": "清远",
        "time": "2020/1/25",
        "tran": "私家车",
    }, {
        "from": "清远",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '咸宁'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20——2020/1/23",
    "rbyy": "武汉停留",
    "bzzzytjd": "患者于2020年1月20日前往武汉探亲，23日自驾从武汉返回深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/8",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/24",
    "fbrq": "2月11日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "35",
    "blh": "378",
    "nationality&native":["中国",""],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin": '武汉'
  },
  {
    "yqtblgx": "病例376女儿",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月20日乘私家车前往湖北通城，29日随父母乘私家车返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/8",
    "lssj": "2020/1/29",
    "fbingsj": "2020/2/8",
    "fbrq": "2月11日",
    "jzd": "深圳市盐田区",
    "fbusj": "24时",
    "nl": "13",
    "blh": "377",
    "nationality&native":["中国",""],
    "track": [{
        "from": "通城",
        "to": "深圳",
        "time": "2020/1/29",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '通城'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月20日自驾车前往湖北通城，29日自驾返回深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/8",
    "lssj": "2020/1/29",
    "fbingsj": "2020/2/8",
    "fbrq": "2月11日",
    "jzd": "深圳市盐田区",
    "fbusj": "24时",
    "nl": "50",
    "blh": "376",
    "nationality&native":["中国",""],
    "track": [{
        "from": "通城",
        "to": "深圳",
        "time": "2020/1/29",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '通城'
  },
  {
    "yqtblgx": "病例361儿子",
    "zwhsjqj": "2020/1/15、2020/1/19",
    "rbyy": "武汉停留",
    "bzzzytjd": "患者于2020年1月15日前往湖北武汉，后自驾前往湖北黄石，19日返回武汉，22日再到黄石。24日从黄石驾车出发，经长沙、韶关，26日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/9",
    "lssj": "2020/1/26",
    "fbingsj": "2020/2/8",
    "fbrq": "2月10日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "21",
    "blh": "375",
    "nationality&native":["中国",""],
    "track": [{
        "from": "武汉",
        "to": "黄石",
        "time": "2020/1/22",
        "tran": "私家车",
    }, {
        "from": "黄石",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '武汉'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾与武汉人员有接触史",
    "bzzzytjd": "患者于2020年1月11日到北京开会，自述有与武汉人员接触史，16日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/1/16",
    "fbingsj": "2020/1/23",
    "fbrq": "2月10日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "41",
    "blh": "374",
    "nationality&native":["中国",""],
    "track": [{
        "from": "北京",
        "to": "深圳",
        "time": "2020/1/16",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '武汉'
  },
  {
    "yqtblgx": "病例372女儿",
    "zwhsjqj": "",
    "rbyy": "曾与武汉来深亲属接触",
    "bzzzytjd": "自述近期无湖北相关旅居史。2020年1月19日后接触过武汉来深亲属。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/9",
    "lssj": "",
    "fbingsj": "2020/2/1",
    "fbrq": "2月10日",
    "jzd": "深圳市宝安区",
    "fbusj": "24时",
    "nl": "10",
    "blh": "373",
    "nationality&native":["中国",""],
    "track":[],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '武汉'
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾与武汉来深亲属接触",
    "bzzzytjd": "自述近期无湖北相关旅居史。2020年1月19日后接触过武汉来深亲属。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/9",
    "lssj": "",
    "fbingsj": "2020/2/6",
    "fbrq": "2月10日",
    "jzd": "深圳市宝安区",
    "fbusj": "24时",
    "nl": "40",
    "blh": "372",
    "nationality&native":["中国",""],
    "track":[],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '探亲',
    "origin": '深圳',
    "detailOrigin": ''
  },
  {
    "yqtblgx": "病例328妻子",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月18日驾车前往湖北鄂州，22日驾车到黄冈，当日发病，23日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/22",
    "fbrq": "2月10日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "51",
    "blh": "371",
    "nationality&native":["中国",""],
    "track": [{
        "from": "鄂州",
        "to": "黄冈",
        "time": "2020/1/22",
        "tran": "私家车",
    }, {
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '鄂州'
  },
  {
    "yqtblgx": "病例366母亲",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "患者于2020年1月18日驾车经湖南楚江，次日抵达湖北洪湖， 24日驾车返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/9",
    "lssj": "2020/1/24",
    "fbingsj": "2020/2/7",
    "fbrq": "2月10日",
    "jzd": "深圳市龙岗区",
    "fbusj": "24时",
    "nl": "62",
    "blh": "370",
    "nationality&native":["中国",""],
    "track": [{
        "from": "楚江",
        "to": "洪湖",
        "time": "2020/1/19",
        "tran": "私家车",
    }, {
        "from": "洪湖",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖南',
    "detailOrigin": '楚江',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "自述近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/9",
    "lssj": "2020/2/3",
    "fbingsj": "2020/1/29",
    "fbrq": "2月10日",
    "jzd": "江西省新余市",
    "fbusj": "12时",
    "nl": "43",
    "blh": "369",
    "nationality&native":["中国",""],
    "track":[],
    "treatment_hospital":"",
    "reason": '',
    "detailReason": '',
    "origin": '江西',
    "detailOrigin": '新余',
  },
  {
    "yqtblgx": "病例342女儿",
    "zwhsjqj": "",
    "rbyy": "有与新冠肺炎确诊病例接触",
    "bzzzytjd": "自述近期无湖北相关旅居史，有与新冠肺炎确诊病例接触",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "",
    "fbingsj": "2020/2/4",
    "fbrq": "2月10日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "37",
    "blh": "368",
    "nationality&native":["中国",""],
    "track":[],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": '',
  },
  {
    "yqtblgx": "病例214丈夫",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "1月16日前往湖北京山，20号返回荆州",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/24",
    "fbrq": "2月10日",
    "jzd": "湖北省荆州市",
    "fbusj": "12时",
    "nl": "61",
    "blh": "367",
    "nationality&native":["中国",""],
    "track": [{
        "from": "京山",
        "to": "荆州",
        "time": "2020/1/20",
        "tran": "",
    }, {
        "from": "荆州",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '荆州',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "于2020年1月19日驾车到湖北洪湖，24日驾车返回深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/8",
    "lssj": "2020/1/24",
    "fbingsj": "2020/2/1",
    "fbrq": "2月9日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "36",
    "blh": "366",
    "nationality&native":["中国",""],
    "track": [{
        "from": "洪湖",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '洪湖',
  },
  {
    "yqtblgx": "病例329妻子",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "于2020年1月21日与家人驾车到湖北黄冈探亲，26日驾车返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/7",
    "lssj": "2020/1/26",
    "fbingsj": "2020/2/5",
    "fbrq": "2月9日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "32",
    "blh": "365",
    "nationality&native":["中国",""],
    "track": [{
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '黄冈',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "2019/12/1——2020/1/13",
    "rbyy": "武汉停留,有与家中新冠肺炎确诊病例接触史",
    "bzzzytjd": "2019年12月1日前往武汉探亲，有与家中新冠肺炎确诊病例接触史，1月13日前往湖北仙桃，20日返回深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/23",
    "fbrq": "2月9日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "18",
    "blh": "364",
    "nationality&native":["中国",""],
    "track": [{
        "from": "仙桃",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '武汉',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "2020/1/6",
    "rbyy": "湖北停留",
    "bzzzytjd": "2020年1月6日前往武汉，后到湖北随州，22日发病，24日从随州驾车返回深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/30",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/22",
    "fbrq": "2月9日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "36",
    "blh": "363",
    "nationality&native":["中国",""],
    "track": [{
        "from": "随州",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '武汉',
  },
  {
    "yqtblgx": "病例335丈夫",
    "zwhsjqj": "",
    "rbyy": "曾接触湖北赤壁来深人员",
    "bzzzytjd": "自述近期无湖北相关旅居史，2020年1月18日接触过湖北赤壁返深人员。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "",
    "fbingsj": "2020/1/21",
    "fbrq": "2月9日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "69",
    "blh": "362",
    "nationality&native":["中国",""],
    "track":[],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": '',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "2020/1/15、2020/1/19",
    "rbyy": "武汉停留",
    "bzzzytjd": "患者于2020年1月15日前往武汉，后自驾前往湖北黄石，19日返回武汉，22日再到黄石。24日从黄石驾车出发，经长沙、韶关，26日抵达深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/29",
    "fbrq": "2月9日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "49",
    "blh": "361",
    "nationality&native":["中国",""],
    "track": [{
        "from": "黄石",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '湖北停留',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin": '武汉',
  },
  {
    "yqtblgx": "病例337儿媳",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "患者于2020年1月19日与家人驾车到江西新余过年，2月1日返回深圳。2月5日发病，2月7日入院。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/7",
    "lssj": "2020/2/1",
    "fbingsj": "2020/2/5",
    "fbrq": "2月9日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "28",
    "blh": "360",
    "nationality&native":["中国",""],
    "track": [{
        "from": "新余",
        "to": "深圳",
        "time": "2020/2/1",
        "tran": "私家车",
    }],
    "treatment_hospital":"",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '江西',
    "detailOrigin": '新余',
  },
  {
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "自述近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/7",
    "lssj": "",
    "fbingsj": "2020/1/21",
    "fbrq": "2月9日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "72",
    "blh": "359",
    "nationality&native":["中国",""],
    "track":[],
    "treatment_hospital":"",
    "reason": '',
    "detailReason": '',
    "origin": '深圳',
    "detailOrigin": '',
  },
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "2020年1月21日从湖南岳阳前往深圳，25日乘私家车前往惠州，27日发病，2月3日到深圳。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/6",
    "lssj": "2020/2/3",
    "fbingsj": "2020/1/27",
    "fbrq": "2月9日",
    "jzd": "湖北省荆州市",
    "fbusj": "12时",
    "nl": "57",
    "blh": "358",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "惠州",
        "to": "深圳",
        "time": "2020/2/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '',
    "origin": '湖南',
    "detailOrigin": '岳阳',
},
{
    "yqtblgx": "病例277女儿",
    "zwhsjqj": "2020/1/20——2020/1/22",
    "rbyy": "武汉停留，病例277女儿",
    "bzzzytjd": "患者于2020年1月20日前往武汉接父母回深圳，22日返回。",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/7",
    "lssj": "2020/1/22",
    "fbingsj": "2020/2/3",
    "fbrq": "2月9日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "30",
    "blh": "357",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/15--2020/1/23",
    "rbyy": "武汉停留",
    "bzzzytjd": "患者常住于湖北武汉。1月15日乘私家车从河南周口到武汉，23日经湖南长沙到广州，24日到普吉岛旅游，27日抵达深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/8",
    "lssj": "2020/1/27",
    "fbingsj": "2020/1/25",
    "fbrq": "2月9日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "39",
    "blh": "356",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "周口",
        "to": "武汉",
        "time": "2020/1/15",
        "tran": "私家车",
    }, {
        "from": "武汉",
        "to": "长沙",
        "time": "2020/1/15",
        "tran": "私家车",
    }, {
        "from": "长沙",
        "to": "广州",
        "time": "2020/1/23",
        "tran": "私家车",
    }, {
        "from": "广州",
        "to": "普吉岛",
        "time": "2020/1/24",
        "tran": "私家车",
    }, {
        "from": "普吉岛",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin": '武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾与武汉返乡亲属有接触",
    "bzzzytjd": "患者于2020年1月22日乘私家车到福建龙岩过年，与从武汉回来的亲属有接触史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/7",
    "lssj": "2020/1/26",
    "fbingsj": "2020/2/1",
    "fbrq": "2月9日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "48",
    "blh": "355",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '',
    "origin": '福建',
    "detailOrigin": '龙岩',
},
{
    "yqtblgx": "病例270妹妹",
    "zwhsjqj": "",
    "rbyy": "与新冠肺炎确诊病例接触",
    "bzzzytjd": "自述近期无湖北相关旅居史，有与新冠肺炎确诊病例接触史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/7",
    "lssj": "",
    "fbingsj": "2020/2/5",
    "fbrq": "2月8日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "37",
    "blh": "354",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": '',
},
{
    "yqtblgx": "病例329儿子",
    "zwhsjqj": "",
    "rbyy": "湖北停留",
    "bzzzytjd": "2020年1月11日随亲属前往湖北黄冈，25日乘私家车返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/6",
    "lssj": "2020/1/25",
    "fbingsj": "2020/2/5",
    "fbrq": "2月8日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "3",
    "blh": "353",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '黄冈',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月28日前往山东济南，后转乘私家车到山东聊城，31日从济南返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "2020/1/31",
    "fbingsj": "2020/1/22",
    "fbrq": "2月8日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "25",
    "blh": "352",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "济南",
        "to": "深圳",
        "time": "2020/1/31",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '',
    "detailReason": '',
    "origin": '山东',
    "detailOrigin": '济南',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/22",
    "rbyy": "武汉停留",
    "bzzzytjd": "2020年1月22日前往湖北武汉，后转乘私家车前往湖北随州，27日乘私家车到河南信阳后返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/4",
    "lssj": "2020/1/27",
    "fbingsj": "2020/2/4",
    "fbrq": "2月8日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "25",
    "blh": "351",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "随州",
        "time": "2020/1/22",
        "tran": "私家车",
    }, {
        "from": "随州",
        "to": "信阳",
        "time": "2020/1/27",
        "tran": "私家车",
    }, {
        "from": "信阳",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin": '武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/4",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/20",
    "fbrq": "2月8日",
    "jzd": "湖北省赤壁市",
    "fbusj": "12时",
    "nl": "67",
    "blh": "350",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '赤壁',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月16日前往湖北咸宁探亲，22日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/2",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/27",
    "fbrq": "2月8日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "36",
    "blh": "349",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "咸宁",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin": '咸宁',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/19——2020/1/20",
    "rbyy": "武汉停留",
    "bzzzytjd": "2020年1月19日前往武汉，20日从武汉出发到伦敦旅游，31日从伦敦前往广州，2020年2月2日到深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "2020/2/2",
    "fbingsj": "2020/1/26",
    "fbrq": "2月8日",
    "jzd": "湖北省宜昌市",
    "fbusj": "12时",
    "nl": "60",
    "blh": "348",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "伦敦",
        "time": "2020/1/20",
        "tran": "",
    }, {
        "from": "伦敦",
        "to": "广州",
        "time": "2020/1/31",
        "tran": "",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/2/2",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin": '武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/19",
    "rbyy": "武汉停留",
    "bzzzytjd": "2020年1月1日到湖北天门，19日从天门途径武汉，稍作停留后返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/7",
    "lssj": "2020/1/19",
    "fbingsj": "2020/2/3",
    "fbrq": "2月8日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "54",
    "blh": "347",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/19",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin": '武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾与武汉来深人员多次接触",
    "bzzzytjd": "自述近期无湖北相关旅居史，2020年1月22-23日，曾与武汉来深人员多次接触",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/1",
    "lssj": "",
    "fbingsj": "2020/1/25",
    "fbrq": "2月8日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "56",
    "blh": "346",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '',
    "origin": '深圳',
    "detailOrigin": '',
},
{
    "yqtblgx": "病例87妻子",
    "zwhsjqj": "——2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "2020/1/23",
    "fbingsj": "2020/2/5",
    "fbrq": "2月8日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "62",
    "blh": "345",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '武汉',
},
{
    "yqtblgx": "病例300父亲",
    "zwhsjqj": "",
    "rbyy": "曾与武汉来深亲属共同就餐",
    "bzzzytjd": "自述近期无湖北相关旅居史，2020年1月20日曾与武汉来深人员共同就餐",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/3",
    "lssj": "",
    "fbingsj": "2020/2/3",
    "fbrq": "2月8日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "63",
    "blh": "344",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": '',
},
{
    "yqtblgx": "病例342丈夫",
    "zwhsjqj": "",
    "rbyy": "曾与武汉来深亲属共同就餐",
    "bzzzytjd": "自述近期无湖北相关旅居史，2020年1月21日曾与武汉来深亲属共同就餐，且来深亲属中有新冠肺炎确诊病例",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/7",
    "lssj": "",
    "fbingsj": "2020/2/7",
    "fbrq": "2月8日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "65",
    "blh": "343",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": '',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾与武汉来深亲属共同就餐",
    "bzzzytjd": "自述近期无湖北相关旅居史，2020年1月21日曾与武汉来深亲属共同就餐，且来深亲属中有新冠肺炎确诊病例",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/7",
    "lssj": "",
    "fbingsj": "2020/1/30",
    "fbrq": "2月8日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "64",
    "blh": "342",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": '',
},
{
    "yqtblgx": "病例245女儿",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月17日随家人自驾到湖北孝感，25日随家人返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "2020/1/25",
    "fbingsj": "2020/2/6",
    "fbrq": "2月8日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "7",
    "blh": "341",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '孝感',
},
{
    "yqtblgx": "病例304儿子",
    "zwhsjqj": "",
    "rbyy": "曾接触湖北赤壁来深人员",
    "bzzzytjd": "患者母亲自述近期无湖北相关旅居史，家人中曾接触湖北赤壁来深人员",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/7",
    "lssj": "",
    "fbingsj": "2020/2/6",
    "fbrq": "2月8日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "6",
    "blh": "340",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '赤壁',
},
{
    "yqtblgx": "病例337妻子",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月19日驾车到江西新余过年，2020年2月1日驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "2020/2/1",
    "fbingsj": "2020/2/2",
    "fbrq": "2月7日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "58",
    "blh": "339",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "新余",
        "to": "深圳",
        "time": "2020/2/1",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '江西',
    "detailOrigin": '新余',
},
{
    "yqtblgx": "病例337儿子",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月19日驾车到江西新余过年，2020年2月1日驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/2/1",
    "fbingsj": "2020/1/31",
    "fbrq": "2月7日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "30",
    "blh": "338",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "新余",
        "to": "深圳",
        "time": "2020/2/1",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '江西',
    "detailOrigin": '新余',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月19日驾车到江西新余过年，2020年2月1日驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/2/1",
    "fbingsj": "2020/2/5",
    "fbrq": "2月7日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "58",
    "blh": "337",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "新余",
        "to": "深圳",
        "time": "2020/2/1",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '江西',
    "detailOrigin": '新余',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月21日驾车到湖北黄冈探亲，24日驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/6",
    "lssj": "2020/1/24",
    "fbingsj": "2020/2/1",
    "fbrq": "2月7日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "43",
    "blh": "336",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin": '黄冈',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "自述近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "",
    "fbingsj": "2020/2/2",
    "fbrq": "2月7日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "66",
    "blh": "335",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '',
    "detailReason": '',
    "origin": '深圳',
    "detailOrigin": '',
},
{
    "yqtblgx": "病例333儿子",
    "zwhsjqj": "",
    "rbyy": "接触确诊病例",
    "bzzzytjd": "2020年1月23日前往贵州贵阳探亲，2020年2月2日返回深圳探亲接触者中有确诊病例",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/2/2",
    "fbingsj": "2020/2/1",
    "fbrq": "2月7日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "11",
    "blh": "334",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "贵阳",
        "to": "深圳",
        "time": "2020/2/2",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": '',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "接触确诊病例",
    "bzzzytjd": "2020年1月23日前往贵州贵阳探亲，2020年2月2日返回深圳探亲接触者中有确诊病例",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/2/2",
    "fbingsj": "2020/1/31",
    "fbrq": "2月7日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "38",
    "blh": "333",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "贵阳",
        "to": "深圳",
        "time": "2020/2/2",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '探亲',
    "origin": '深圳',
    "detailOrigin": '深圳',
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/18",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月18日从武汉到马来西亚旅游，26日从马来西亚到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/4",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/22",
    "fbrq": "2月7日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "36",
    "blh": "332",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "马来西亚",
        "time": "2020/1/18",
        "tran": "",
    }, {
        "from": "马来西亚",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin": '武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "自述近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/4",
    "lssj": "",
    "fbingsj": "2020/2/2",
    "fbrq": "2月7日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "39",
    "blh": "331",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '',
    "detailReason": '',
    "origin": '深圳',
    "detailOrigin": '',
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月22日从武汉出发抵达深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/6",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/26",
    "fbrq": "2月7日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "53",
    "blh": "330",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin": '武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月22日自驾到湖北黄冈，26日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/4",
    "lssj": "2020/1/26",
    "fbingsj": "2020/2/3",
    "fbrq": "2月7日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "34",
    "blh": "329",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '',
    "origin": '湖北',
    "detailOrigin": '黄冈',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月18日驾车到湖北鄂州，21日前往黄冈探亲，23日从黄冈驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/1/23",
    "fbingsj": "2020/2/4",
    "fbrq": "2月7日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "54",
    "blh": "328",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin": '黄冈',
},
{
    "yqtblgx": "病例87孙子",
    "zwhsjqj": "",
    "rbyy": "接触从武汉来的亲属",
    "bzzzytjd": "家人自述近期无湖北相关旅居史，2020年1月24日起接触从武汉来的亲属",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "",
    "fbingsj": "2020/2/5",
    "fbrq": "2月7日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "2",
    "blh": "327",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": '',
},
{
    "yqtblgx": "病例262妻子",
    "zwhsjqj": "2020/1/15——2020/1/23",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月15日驾车到武汉，23日驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "2020/1/23",
    "fbingsj": "2020/2/4",
    "fbrq": "2月7日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "66",
    "blh": "326",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '武汉',
},
{
    "yqtblgx": "病例250妻子",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月23日驾车到湖北潜江，25日驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/6",
    "lssj": "2020/1/25",
    "fbingsj": "2020/2/3",
    "fbrq": "2月7日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "36",
    "blh": "325",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "潜江",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '潜江',
},
{
    "yqtblgx": "病例250女儿",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月23日随家人驾车到湖北潜江，25日随亲属驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/6",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/29",
    "fbrq": "2月7日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "5",
    "blh": "324",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "潜江",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '潜江',
},
{
    "yqtblgx": "病例171妻子",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "自述近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "",
    "fbingsj": "2020/2/5",
    "fbrq": "2月7日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "60",
    "blh": "323",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin": '',
},
{
    "yqtblgx": "病例245父亲",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "2020年1月25日随儿子驾车到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/1/25",
    "fbingsj": "2020/2/5",
    "fbrq": "2月7日",
    "jzd": "湖北省孝感市",
    "fbusj": "12时",
    "nl": "66",
    "blh": "322",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '孝感',
},
{
    "yqtblgx": "病例245母亲",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "2020年1月25日随儿子驾车到深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "2020/1/25",
    "fbingsj": "2020/2/5",
    "fbrq": "2月7日",
    "jzd": "湖北省孝感市",
    "fbusj": "12时",
    "nl": "65",
    "blh": "321",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '孝感',
},
{
    "yqtblgx": "病例43儿媳",
    "zwhsjqj": "",
    "rbyy": "接触从武汉来的亲属",
    "bzzzytjd": "自述近期无湖北相关旅居史，其亲属2020年1月22号从武汉来深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "",
    "fbingsj": "2020/2/4",
    "fbrq": "2月7日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "33",
    "blh": "320",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '武汉',
},
{
    "yqtblgx": "病例252儿子",
    "zwhsjqj": "2020/1/21——2020/1/23",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月21日驾车到武汉，23日到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/26",
    "fbrq": "2月7日",
    "jzd": "江苏省无锡市",
    "fbusj": "12时",
    "nl": "46",
    "blh": "319",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin": '武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20",
    "rbyy": "在武汉停留",
    "bzzzytjd": "2020年1月19日到广州，20号抵达武汉，同日前往北京，22日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/21",
    "fbrq": "2月7日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "38",
    "blh": "318",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "广州",
        "to": "武汉",
        "time": "2020/1/19",
        "tran": "",
    }, {
        "from": "武汉",
        "to": "北京",
        "time": "2020/1/20",
        "tran": "",
    }, {
        "from": "北京",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin": '武汉',
},
{
    "yqtblgx": "病例193儿子",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月16日随亲属前往湖北咸宁，25日随家人驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/1/25",
    "fbingsj": "2020/2/5",
    "fbrq": "2月7日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "2",
    "blh": "317",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "咸宁",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露',
},
{
    "yqtblgx": "病例315妻子",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月20日从深圳驾车到江西抚州，24日到赣州，31日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "2020/1/31",
    "fbingsj": "2020/1/27",
    "fbrq": "2月6日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "41",
    "blh": "316",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "赣州",
        "to": "深圳",
        "time": "2020/1/31",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '江西',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月13-18日前往惠州淡水出差，20日从深圳驾车到江西抚州，24日到赣州，31日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/5",
    "lssj": "2020/1/31",
    "fbingsj": "2020/1/27",
    "fbrq": "2月6日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "56",
    "blh": "315",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "赣州",
        "to": "深圳",
        "time": "2020/1/31",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "origin": '江西',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "病例308老公",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月17日从深圳出发，经香港到马来西亚，20日乘车到新加坡，21日抵达香港，后乘车返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/3",
    "lssj": "2020/1/21",
    "fbingsj": "2020/2/1",
    "fbrq": "2月6日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "69",
    "blh": "314",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "马来西亚",
        "to": "新加坡",
        "time": "2020/1/20",
        "tran": "",
    }, {
        "from": "新加坡",
        "to": "香港",
        "time": "2020/1/21",
        "tran": "",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '新加坡',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例268儿子",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "自述近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/3",
    "lssj": "",
    "fbingsj": "2020/2/3",
    "fbrq": "2月6日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "13",
    "blh": "313",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例245女儿",
    "zwhsjqj": "2020/1/17——2020/1/24",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月17日乘私家车到湖北武汉和孝感探亲，24日从孝感返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/4",
    "lssj": "2020/1/24",
    "fbingsj": "2020/2/3",
    "fbrq": "2月6日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "2",
    "blh": "312",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例245妻子",
    "zwhsjqj": "2020/1/17——2020/1/24",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月17日驾车到湖北武汉和孝感探亲，24日从孝感自驾返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/3",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/28",
    "fbrq": "2月6日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "34",
    "blh": "311",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例309妻子",
    "zwhsjqj": "2020/1/19——2020/1/23",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月19日前往武汉，23日驾车到江西南昌，25日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/4",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/27",
    "fbrq": "2月6日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "49",
    "blh": "310",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "南昌",
        "time": "2020/1/23",
        "tran": "私家车",
    }, {
        "from": "南昌",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/19——2020/1/23",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月19日前往武汉，23日驾车到江西南昌，25日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/4",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/27",
    "fbrq": "2月6日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "50",
    "blh": "309",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "南昌",
        "time": "2020/1/23",
        "tran": "私家车",
    }, {
        "from": "南昌",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月17日从深圳出发，经香港到马来西亚，20日乘车到新加坡， 21日抵达香港，后乘车返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/3",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/28",
    "fbrq": "2月6日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "64",
    "blh": "308",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "马来西亚",
        "to": "新加坡",
        "time": "2020/1/20",
        "tran": "",
    }, {
        "from": "新加坡",
        "to": "香港",
        "time": "2020/1/21",
        "tran": "",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '新加坡',
    "reason": '境外返回',
    "detailReason": '境外返回'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/10——2020/1/21",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月10日前往武汉，21日到北京，26日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/1",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/26",
    "fbrq": "2月6日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "63",
    "blh": "307",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "北京",
        "time": "2020/1/21",
        "tran": "",
    }, {
        "from": "北京",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/19",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月19日到泰国普吉岛旅游，24日从普吉岛出发抵达深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/3",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/24",
    "fbrq": "2月6日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "28",
    "blh": "306",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "普吉岛",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '泰国',
    "reason": '境外返回',
    "detailReason": '境外返回'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月14日到泰国曼谷旅游，19日返回深圳，22号乘车到广东梅州兴宁，27日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/3",
    "lssj": "2020/1/27",
    "fbingsj": "2020/2/1",
    "fbrq": "2月6日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "30",
    "blh": "305",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "梅州",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '泰国',
    "reason": '境外返回',
    "detailReason": '境外返回'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾接触湖北赤壁来深人员",
    "bzzzytjd": "自述近期无湖北相关旅居史，曾接触湖北赤壁来深人员",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/4",
    "lssj": "",
    "fbingsj": "2020/1/20",
    "fbrq": "2月6日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "42",
    "blh": "304",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18",
    "rbyy": "在武汉停留",
    "bzzzytjd": "2020年1月18日前往武汉，后乘私家车到湖北孝感，21日乘私家车到湖北荆门，25日自驾到深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/4",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/28",
    "fbrq": "2月6日",
    "jzd": "四川省成都市",
    "fbusj": "12时",
    "nl": "57",
    "blh": "303",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "荆门",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月18日从东莞返回深圳，自述近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/4",
    "lssj": "2020/1/18",
    "fbingsj": "2020/2/2",
    "fbrq": "2月6日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "23",
    "blh": "302",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "东莞",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '广东',
    "reason": '',
    "detailReason": ''
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/9",
    "rbyy": "在武汉停留",
    "bzzzytjd": "2020年1月9日前往武汉，然后乘车到湖北鄂州，19日抵达浙江杭州，21日前往福建厦门，22日到鼓浪屿，23日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/3",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/25",
    "fbrq": "2月6日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "23",
    "blh": "301",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "鄂州",
        "time": "2020/1/9",
        "tran": "",
    }, {
        "from": "鄂州",
        "to": "杭州",
        "time": "2020/1/19",
        "tran": "",
    }, {
        "from": "杭州",
        "to": "厦门",
        "time": "2020/1/21",
        "tran": "",
    }, {
        "from": "厦门",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例299男友",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月19-24日在菲律宾马尼拉市进修，24日从马尼拉市返回深圳，27日驾车前往江西赣州，28日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/3",
    "lssj": "2020/1/28",
    "fbingsj": "2020/2/3",
    "fbrq": "2月6日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "31",
    "blh": "300",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "赣州",
        "to": "深圳",
        "time": "2020/1/28",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '江西',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月22日前往江西赣州，28日驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/4",
    "lssj": "2020/1/28",
    "fbingsj": "2020/2/4",
    "fbrq": "2月6日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "23",
    "blh": "299",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "赣州",
        "to": "深圳",
        "time": "2020/1/28",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '江西',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月22日前往湖南株洲，然后乘私家车到湖南醴陵，24日经株洲回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/3",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/24",
    "fbrq": "2月6日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "52",
    "blh": "298",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "株洲",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月19日驾车前往湖北孝感，25日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/4",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/31",
    "fbrq": "2月6日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "38",
    "blh": "297",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/10——2020/1/22",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月10日前往武汉武汉，16日发病，22日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/5",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/16",
    "fbrq": "2月6日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "20",
    "blh": "296",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/22",
    "rbyy": "在武汉停留",
    "bzzzytjd": "2020年1月10日前往湖北京山，22日从京山出发，经武汉抵达深圳，在京山期间有与确诊病例接触史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/2",
    "lssj": "2020/1/22",
    "fbingsj": "2020/2/1",
    "fbrq": "2月6日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "58",
    "blh": "295",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "京山",
        "to": "武汉",
        "time": "2020/1/22",
        "tran": "",
    }, {
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾接触确诊病例",
    "bzzzytjd": "2020年1月18日从深圳出发，自驾经江西于都到河南信阳，21日回南阳探亲，22日前往信阳。自述在信阳期间曾接触确诊病例，22日当晚返回南阳，25日自驾回深，26日抵达",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/3",
    "lssj": "2020/1/26",
    "fbingsj": "2020/2/2",
    "fbrq": "2月6日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "42",
    "blh": "294",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "南阳",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '河南',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/4",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/28",
    "fbrq": "2月6日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "37",
    "blh": "293",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/2",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/23",
    "fbrq": "2月6日",
    "jzd": "湖北省宜昌市",
    "fbusj": "12时",
    "nl": "46",
    "blh": "292",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "与武汉归来人员接触",
    "bzzzytjd": "近期有与武汉归来人员接触史，无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/3",
    "lssj": "",
    "fbingsj": "2020/2/3",
    "fbrq": "2月5日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "47",
    "blh": "291",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/23",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月23日乘私家车前往湖南岳阳，下午到达深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/4",
    "lssj": "2020/1/23",
    "fbingsj": "2020/2/1",
    "fbrq": "2月5日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "61",
    "blh": "290",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "岳阳",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "年初因公各地出差，2020年1月3日从浙江宁波出发前往湖北武汉，后到达襄阳东，5日返回武汉后，转车至江西景德镇，2020年1月21日抵达深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/4",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/22",
    "fbrq": "2月5日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "43",
    "blh": "289",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "宁波",
        "to": "武汉",
        "time": "2020/1/3",
        "tran": "",
    }, {
        "from": "武汉",
        "to": "景德镇",
        "time": "2020/1/5",
        "tran": "",
    }, {
        "from": "景德镇",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "否认近期有湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/3",
    "lssj": "",
    "fbingsj": "2020/1/27",
    "fbrq": "2月5日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "56",
    "blh": "288",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "origin": '深圳',
    "treatment_hospital": "",
    "reason": '',
    "detailReason": ''
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月20日自驾到湖北安陆，25日回深",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/2",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/26",
    "fbrq": "2月5日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "60",
    "blh": "287",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "安陆",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21",
    "rbyy": "在武汉停留",
    "bzzzytjd": "2020年1月19日自驾到湖北安陆，21日到武汉，当日返回安陆，26日自驾返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/2",
    "lssj": "2020/1/26",
    "fbingsj": "2020/2/1",
    "fbrq": "2月5日",
    "jzd": "深圳市光明区",
    "fbusj": "12时",
    "nl": "26",
    "blh": "286",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "安陆",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例209儿媳",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月17-19日驾车到湖北洪湖，20日自驾到仙桃，22日返回洪湖，25日自驾回深",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/2",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/30",
    "fbrq": "2月5日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "28",
    "blh": "285",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "洪湖",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例278丈夫",
    "zwhsjqj": "——2020/1/23",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/1",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/26",
    "fbrq": "2月5日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "56",
    "blh": "284",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "origin": '湖北',
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例141妻子",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "否认近期有湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/2",
    "lssj": "",
    "fbingsj": "2020/1/30",
    "fbrq": "2月5日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "78",
    "blh": "283",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例280女儿",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月20日乘私家车到湖北鄂州， 25日返深",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/3",
    "lssj": "2020/1/25",
    "fbingsj": "2020/2/2",
    "fbrq": "2月5日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "7",
    "blh": "282",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "鄂州",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例280妻子",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月20日驾车到湖北鄂州， 25日返深",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/3",
    "lssj": "2020/1/25",
    "fbingsj": "2020/2/1",
    "fbrq": "2月5日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "37",
    "blh": "281",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "鄂州",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月20日驾车到湖北鄂州， 25日返深",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/3",
    "lssj": "2020/1/25",
    "fbingsj": "2020/2/1",
    "fbrq": "2月5日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "36",
    "blh": "280",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "鄂州",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月20-27日从武汉到泰国旅行，27日抵达深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "2020/1/27",
    "fbingsj": "2020/1/29",
    "fbrq": "2月5日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "30",
    "blh": "279",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "泰国",
        "time": "2020/1/20",
        "tran": "",
    }, {
        "from": "泰国",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/23",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/2",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/25",
    "fbrq": "2月5日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "55",
    "blh": "278",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20——2020/1/22",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月20日前往武汉，22日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/30",
    "fbrq": "2月5日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "58",
    "blh": "277",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/17——2020/1/22",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月17日前往武汉，22日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/22",
    "fbrq": "2月5日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "28",
    "blh": "276",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例89女儿",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "否认近期有湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "",
    "fbingsj": "2020/1/28",
    "fbrq": "2月5日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "37",
    "blh": "275",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例135婆婆",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "2020年1月22日乘私家车经武汉前往深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/31",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/22",
    "fbrq": "2月5日",
    "jzd": "湖北省荆州市",
    "fbusj": "12时",
    "nl": "79",
    "blh": "274",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18——2020/1/21",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月18日前往武汉，21日到孝感老家，24日乘私家车到广东中山，25日换乘的士到广州返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/30",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/26",
    "fbrq": "2月5日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "45",
    "blh": "273",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "孝感",
        "time": "2020/1/18",
        "tran": "",
    }, {
        "from": "孝感",
        "to": "中山",
        "time": "2020/1/24",
        "tran": "私家车",
    }, {
        "from": "中山",
        "to": "广州",
        "time": "2020/1/24",
        "tran": "私家车",
    }, {
        "from": "广州",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "的士",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/12——2020/1/23",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月12日前往武汉，23日自驾返深",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/2",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/28",
    "fbrq": "2月5日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "59",
    "blh": "272",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月22日前往沈阳后，乘私家车到抚顺，27日回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/2",
    "lssj": "2020/1/27",
    "fbingsj": "2020/1/25",
    "fbrq": "2月4日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "45",
    "blh": "271",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "沈阳",
        "to": "抚顺",
        "time": "2020/1/22",
        "tran": "",
    },{
        "from": "抚顺",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '辽宁',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/3",
    "lssj": "",
    "fbingsj": "2020/1/26",
    "fbrq": "2月4日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "50",
    "blh": "270",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "origin": '深圳',
    "treatment_hospital": "",
    "reason": '',
    "detailReason": ''
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月20日前往湖北孝感，23日到湖南长沙转车到深圳，后直接去往香港，2月1日入境深圳，",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/2",
    "lssj": "2020/1/23",
    "fbingsj": "2020/2/1",
    "fbrq": "2月4日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "20",
    "blh": "269",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "长沙",
        "time": "2020/1/23",
        "tran": "",
    }, {
        "from": "长沙",
        "to": "香港",
        "time": "2020/1/23",
        "tran": "",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/2/1",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "",
    "fbingsj": "2020/1/24",
    "fbrq": "2月4日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "44",
    "blh": "268",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '',
    "origin": '深圳',
    "detailReason": ''
},
{
    "yqtblgx": "病例255阿姨",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "",
    "fbingsj": "2020/1/30",
    "fbrq": "2月4日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "50",
    "blh": "267",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/16——2020/1/18",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月16-18日在武汉，19日回到深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/22",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/20",
    "fbrq": "2月4日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "47",
    "blh": "266",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/19",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/15",
    "rbyy": "经过武汉",
    "bzzzytjd": "2020年1月15日经武汉到湖北孝感，再乘车到湖北随州，25日驾车回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/1",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/30",
    "fbrq": "2月4日",
    "jzd": "深圳市坪山区",
    "fbusj": "12时",
    "nl": "44",
    "blh": "265",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "孝感",
        "time": "2020/1/15",
        "tran": "",
    }, {
        "from": "孝感",
        "to": "随州",
        "time": "2020/1/15",
        "tran": "",
    }, {
        "from": "随州",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例255女儿",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "",
    "fbingsj": "2020/1/28",
    "fbrq": "2月4日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "4",
    "blh": "264",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "接触过湖北地区人员",
    "bzzzytjd": "近期接触过湖北地区人员",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "",
    "fbingsj": "2020/1/23",
    "fbrq": "2月4日",
    "jzd": "广东省惠州市",
    "fbusj": "12时",
    "nl": "39",
    "blh": "263",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '广东',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/14——2020/1/23",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月14日自驾车从深圳到武汉，23日驾车从武汉到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/2",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/25",
    "fbrq": "2月4日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "71",
    "blh": "262",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例255妻子",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "",
    "fbingsj": "2020/1/28",
    "fbrq": "2月4日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "34",
    "blh": "261",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "",
    "fbingsj": "2020/1/24",
    "fbrq": "2月4日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "48",
    "blh": "260",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '',
    "detailReason": ''
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18——2020/1/19",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月18日前往武汉，19日驾车到湖北襄阳，25日抵达广东珠海，27日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "2020/1/27",
    "fbingsj": "2020/1/27",
    "fbrq": "2月4日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "28",
    "blh": "259",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "襄阳",
        "time": "2020/1/19",
        "tran": "私家车",
    }, {
        "from": "襄阳",
        "to": "珠海",
        "time": "2020/1/25",
        "tran": "",
    }, {
        "from": "珠海",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/30",
    "fbrq": "2月4日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "25",
    "blh": "258",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例126女儿",
    "zwhsjqj": "2020/1/23",
    "rbyy": "经过武汉",
    "bzzzytjd": "2020年1月23日自驾车从湖北黄冈到武汉，后抵达深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/29",
    "fbrq": "2月4日",
    "jzd": "湖北省黄冈市",
    "fbusj": "12时",
    "nl": "45",
    "blh": "257",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄冈",
        "to": "武汉",
        "time": "2020/1/23",
        "tran": "私家车",
    }, {
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例251儿子",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月18日驾车从深圳到湖北孝感，25日回到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/2",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/27",
    "fbrq": "2月4日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "18",
    "blh": "256",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例133同事",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "",
    "fbingsj": "2020/1/26",
    "fbrq": "2月4日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "34",
    "blh": "255",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18——2020/1/21",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月17日驾车从深圳到湖北荆州，18日自驾车从荆州到武汉，21日返回荆州，24日自驾车至深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/2",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/22",
    "fbrq": "2月4日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "48",
    "blh": "254",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "荆州",
        "time": "2020/1/21",
        "tran": "私家车",
    }, {
        "from": "荆州",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例214儿媳",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/31",
    "lssj": "",
    "fbingsj": "2020/1/25",
    "fbrq": "2月4日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "34",
    "blh": "253",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/16——2020/1/23",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月16日驾车从深圳到湖北武汉，23日自驾回到深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/26",
    "fbrq": "2月4日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "67",
    "blh": "252",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月18日驾车从深圳到湖北孝感，25日回到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/2",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/29",
    "fbrq": "2月4日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "46",
    "blh": "251",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月23日驾车从深圳到湖北潜江，25日回到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/27",
    "fbrq": "2月4日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "38",
    "blh": "250",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "潜江",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "病例220丈夫",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月16日驾车从深圳到湖北荆州，26日回深",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/22",
    "fbrq": "2月4日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "50",
    "blh": "249",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "荆州",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例206父亲",
    "zwhsjqj": "——2020/1/19",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月19日从武汉到新加坡，26日从新加坡到深圳。",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/27",
    "fbrq": "2月4日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "46",
    "blh": "248",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "新加坡",
        "time": "2020/1/19",
        "tran": "",
    }, {
        "from": "新加坡",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例47外婆",
    "zwhsjqj": "——2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/30",
    "fbrq": "2月4日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "65",
    "blh": "247",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月13日驾车从深圳到湖北枣阳，28日自驾回到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/3",
    "lssj": "2020/1/28",
    "fbingsj": "2020/1/27",
    "fbrq": "2月4日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "31",
    "blh": "246",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "枣阳",
        "to": "深圳",
        "time": "2020/1/28",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/17——2020/1/24",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月17日驾车前往湖北武汉、孝感，24日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/1",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/30",
    "fbrq": "2月3日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "40",
    "blh": "245",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例114岳父",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月16日前往湖南冷水江，27日从邵阳到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "2020/1/27",
    "fbingsj": "2020/1/26",
    "fbrq": "2月3日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "65",
    "blh": "244",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "邵阳",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖南',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "2020年1月22日从武汉驾车到湖北襄阳，25日到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/20",
    "fbrq": "2月3日",
    "jzd": "湖北省枣阳市",
    "fbusj": "12时",
    "nl": "35",
    "blh": "243",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "襄阳",
        "time": "2020/1/22",
        "tran": "私家车",
    }, {
        "from": "襄阳",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "病例209儿子",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月17-19日驾车前往湖北洪湖，20日到仙桃，22日返回洪湖，25日到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/2",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/30",
    "fbrq": "2月3日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "31",
    "blh": "242",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "洪湖",
        "to": "襄阳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留",
    "bzzzytjd": "2020年1月18日驾车前往河南洛阳，在湖北省内高速服务区停留就餐，23日到深圳，",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/27",
    "fbrq": "2月3日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "36",
    "blh": "241",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "洛阳",
        "to": "湖北",
        "time": "2020/1/18",
        "tran": "私家车",
    }, {
        "from": "湖北",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/19——2020/1/20",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月19日前往武汉，20日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/31",
    "fbrq": "2月3日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "66",
    "blh": "240",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月19日前往湖北孝感，24日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/30",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/30",
    "fbrq": "2月3日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "33",
    "blh": "239",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "病例220儿子",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月16日随家人驾车前往湖北荆州，26日回深",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/1",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/30",
    "fbrq": "2月3日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "13",
    "blh": "238",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "荆州",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例210妻子",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "",
    "fbingsj": "2020/1/23",
    "fbrq": "2月3日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "31",
    "blh": "237",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "近期无湖北相关旅居史",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "",
    "fbingsj": "2020/1/21",
    "fbrq": "2月3日",
    "jzd": "深圳市光明区",
    "fbusj": "12时",
    "nl": "56",
    "blh": "236",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "origin": '深圳',
    "treatment_hospital": "",
    "reason": '',
    "detailReason": ''
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/30",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/29",
    "fbrq": "2月3日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "58",
    "blh": "235",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "无湖北相关旅居史。23日前往广东陆丰老家，30日返深",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "2020/1/30",
    "fbingsj": "2020/1/26",
    "fbrq": "2月3日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "35",
    "blh": "234",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "陆丰",
        "to": "深圳",
        "time": "2020/1/30",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '广东',
    "reason": '',
    "detailReason": ''
},
{
    "yqtblgx": "病例172妻子",
    "zwhsjqj": "——2020/1/19",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/30",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/18",
    "fbrq": "2月3日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "41",
    "blh": "233",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例106小姨",
    "zwhsjqj": "——2020/1/19",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/31",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/28",
    "fbrq": "2月3日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "53",
    "blh": "232",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例132丈夫",
    "zwhsjqj": "2020/1/18——2020/1/23",
    "rbyy": "武汉探亲",
    "bzzzytjd": "2020年1月18日驾车前往武汉探亲，23日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/27",
    "fbrq": "2月3日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "43",
    "blh": "231",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例198女儿",
    "zwhsjqj": "2020/1/20",
    "rbyy": "在武汉停留",
    "bzzzytjd": "2020年1月19日前往河南固始，20日到武汉，21日返回固始，27日离开河南，28日抵深",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/31",
    "lssj": "2020/1/28",
    "fbingsj": "2020/1/31",
    "fbrq": "2月3日",
    "jzd": "深圳市光明区",
    "fbusj": "12时",
    "nl": "7",
    "blh": "230",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "固始",
        "to": "武汉",
        "time": "2020/1/20",
        "tran": "",
    }, {
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/28",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "近期无湖北省相关旅居史",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/2",
    "lssj": "",
    "fbingsj": "2020/1/16",
    "fbrq": "2月3日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "34",
    "blh": "229",
    "nationality&native": [
        "",
        ""
    ],
    "origin": '深圳',
    "track": [],
    "treatment_hospital": "",
    "reason": '',
    "detailReason": ''
},
{
    "yqtblgx": "病例199孙子",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月11日前往湖北黄冈，27日包车前往江西南昌，28日抵深",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/2/1",
    "lssj": "2020/1/28",
    "fbingsj": "2020/2/1",
    "fbrq": "2月3日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "8",
    "blh": "228",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄冈",
        "to": "南昌",
        "time": "2020/1/27",
        "tran": "私家车",
    }, {
        "from": "南昌",
        "to": "深圳",
        "time": "2020/1/28",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "origin": '湖北',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例185女儿",
    "zwhsjqj": "2020/1/18",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月18日前往武汉，19日到达河南南阳，23日驾车到湖北孝感，25日返回南阳，26日回到深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "2020/1/26",
    "fbingsj": "2020/2/1",
    "fbrq": "2月3日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "12",
    "blh": "227",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "南阳",
        "to": "武汉",
        "time": "2020/1/18",
        "tran": "",
    }, {
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月18日驾车前往湖北安陆，24日经湖南株洲，25日到深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/26",
    "fbrq": "2月3日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "37",
    "blh": "226",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "安陆",
        "to": "株洲",
        "time": "2020/1/24",
        "tran": "",
    }, {
        "from": "株洲",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "病例183母亲",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月16日驾车前往湖北天门， 23日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/31",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/31",
    "fbrq": "2月3日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "50",
    "blh": "225",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "天门",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "自驾车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例183父亲",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月16日驾车前往湖北天门， 23日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/25",
    "fbrq": "2月3日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "50",
    "blh": "224",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "天门",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "自驾车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例217妻子",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月14日前往黑龙江哈尔滨，26日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/31",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/29",
    "fbrq": "2月3日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "40",
    "blh": "223",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "哈尔滨",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '黑龙江',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例78妻子",
    "zwhsjqj": "——2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/24",
    "fbrq": "2月3日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "67",
    "blh": "222",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例220女儿",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月16日驾车前往湖北荆州，26日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/30",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/28",
    "fbrq": "2月3日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "17",
    "blh": "221",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "荆州",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月16日驾车前往湖北荆州，26日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/30",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/30",
    "fbrq": "2月3日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "45",
    "blh": "220",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "荆州",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "病例186母亲",
    "zwhsjqj": "2020/1/22",
    "rbyy": "湖北居住",
    "bzzzytjd": "2020年1月22日随儿子到武汉乘车前往深圳。30日，在密切接触者采样检测中发现新型冠状病毒阳性，随后入院，31日发病",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/30",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/31",
    "fbrq": "2月3日",
    "jzd": "湖北省鄂州市",
    "fbusj": "12时",
    "nl": "60",
    "blh": "219",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例24妻子",
    "zwhsjqj": "——2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/22",
    "fbrq": "2月3日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "61",
    "blh": "218",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月14日前往黑龙江哈尔滨，26日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/30",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/26",
    "fbrq": "2月3日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "41",
    "blh": "217",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "哈尔滨",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '黑龙江',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "病例133同事",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "无湖北活动史",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "",
    "fbingsj": "2020/1/25",
    "fbrq": "2月3日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "48",
    "blh": "216",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在深圳龙岗参加完酒席",
    "bzzzytjd": "2020年1月18日在深圳龙岗参加完酒席，前往惠州及坪山坑梓老家，短暂停留后驾车返回福田家中",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "",
    "fbingsj": "2020/1/29",
    "fbrq": "2月3日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "57",
    "blh": "215",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "惠州",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/21",
    "rbyy": "湖北居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/31",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/24",
    "fbrq": "2月3日",
    "jzd": "湖北省荆州市",
    "fbusj": "12时",
    "nl": "59",
    "blh": "214",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/30",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/22",
    "fbrq": "2月3日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "76",
    "blh": "213",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/19",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/30",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/20",
    "fbrq": "2月3日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "70",
    "blh": "212",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾密切接触一位新冠确诊患者",
    "bzzzytjd": "2020年1月21日前往湖南岳阳，22-25日曾密切接触一位新冠确诊患者（该患者从湖北荆州出发，到岳阳与其见面），25日自驾回深",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/2/1",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/25",
    "fbrq": "2月3日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "33",
    "blh": "211",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "岳阳",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖南',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月23日前往澳门，24日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/26",
    "fbrq": "2月3日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "36",
    "blh": "210",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "澳门",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '澳门',
    "reason": '境外返回',
    "detailReason": '境外返回'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "2020年1月21日驾车前往仙桃，22日返回洪湖，25日驾车到深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/30",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/22",
    "fbrq": "2月3日",
    "jzd": "湖北省洪湖市",
    "fbusj": "12时",
    "nl": "56",
    "blh": "209",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "洪湖",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/16——2020/1/19",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月16日前往武汉，19日驾车到孝感，24日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/31",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/24",
    "fbrq": "2月3日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "28",
    "blh": "208",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月20日前往湖北荆州，25日经湖南岳阳到广州，后转车至深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/31",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/27",
    "fbrq": "2月2日",
    "jzd": "深圳市光明区",
    "fbusj": "12时",
    "nl": "5",
    "blh": "207",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "荆州",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/19",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月19日从武汉到新加坡，26日从新加坡抵达深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/30",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/29",
    "fbrq": "2月2日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "9",
    "blh": "206",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "新加坡",
        "time": "2020/1/19",
        "tran": "",
    }, {
        "from": "新加坡",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例179妻子",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月8日前往湖北枝江，24日驾车返回深圳，",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/31",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/24",
    "fbrq": "2月2日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "53",
    "blh": "205",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "枝江",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例179孙子",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月8日前往湖北枝江，24日驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/30",
    "fbrq": "2月2日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "6",
    "blh": "204",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "枝江",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例179儿子",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月22日驾车前往湖北枝江，24日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/30",
    "fbrq": "2月2日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "32",
    "blh": "203",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "枝江",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例201妻子",
    "zwhsjqj": "——2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/30",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/30",
    "fbrq": "2月2日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "60",
    "blh": "202",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/30",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/30",
    "fbrq": "2月2日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "62",
    "blh": "201",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/28",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/25",
    "fbrq": "2月2日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "25",
    "blh": "200",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月11日前往湖北黄冈，25日从黄冈经江西九江、湖南衡阳，26日到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/30",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/28",
    "fbrq": "2月2日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "55",
    "blh": "199",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20",
    "rbyy": "在武汉停留",
    "bzzzytjd": "2020年1月19日驾车前往河南固始，20日到武汉，21日回到河南固始家中，27日自驾到深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/28",
    "lssj": "2020/1/27",
    "fbingsj": "2020/1/24",
    "fbrq": "2月2日",
    "jzd": "深圳市光明区",
    "fbusj": "12时",
    "nl": "33",
    "blh": "198",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例190丈夫",
    "zwhsjqj": "——2020/1/23",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月23日从武汉到柬埔寨，28日从柬埔寨到深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/31",
    "lssj": "2020/1/28",
    "fbingsj": "2020/1/27",
    "fbrq": "2月2日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "62",
    "blh": "197",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "柬埔寨",
        "time": "2020/1/23",
        "tran": "",
    }, {
        "from": "柬埔寨",
        "to": "深圳",
        "time": "2020/1/28",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "与武汉人员接触",
    "bzzzytjd": "2020年1月19日自驾到长沙，曾与武汉友人聚餐，21日自驾到湖南株洲，27日返回东莞",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "",
    "fbingsj": "2020/1/25",
    "fbrq": "2月2日",
    "jzd": "广东省东莞市",
    "fbusj": "12时",
    "nl": "48",
    "blh": "196",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "东莞",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖南',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "病例193妻子",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月20日驾车前往湖北咸宁，25日返回深圳，",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/30",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/26",
    "fbrq": "2月2日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "31",
    "blh": "195",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "咸宁",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "2020年1月11日拼车从湖北荆州到湖南岳阳，后乘车前往深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/28",
    "lssj": "2020/1/11",
    "fbingsj": "2020/1/28",
    "fbrq": "2月2日",
    "jzd": "湖北省公安县",
    "fbusj": "12时",
    "nl": "66",
    "blh": "194",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "荆州",
        "to": "岳阳",
        "time": "2020/1/11",
        "tran": "",
    }, {
        "from": "岳阳",
        "to": "深圳",
        "time": "2020/1/11",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月20日驾车前往湖北咸宁，25日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/27",
    "fbrq": "2月2日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "35",
    "blh": "193",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "咸宁",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/22",
    "fbrq": "2月2日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "61",
    "blh": "192",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例131母亲",
    "zwhsjqj": "——2020/1/17",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月17日从武汉到昆明，期间参加旅游团， 24日从昆明抵达深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/28",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/27",
    "fbrq": "2月2日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "34",
    "blh": "191",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "昆明",
        "time": "2020/1/17",
        "tran": "",
    }, {
        "from": "昆明",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/23",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月23日前往柬埔寨，29日从柬埔寨到深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "2020/1/29",
    "fbingsj": "2020/1/28",
    "fbrq": "2月2日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "58",
    "blh": "190",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "柬埔寨",
        "time": "2020/1/23",
        "tran": "",
    }, {
        "from": "柬埔寨",
        "to": "深圳",
        "time": "2020/1/29",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/23",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月23日前往柬埔寨，28日从柬埔寨到深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "2020/1/28",
    "fbingsj": "2020/1/26",
    "fbrq": "2月2日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "62",
    "blh": "189",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "柬埔寨",
        "time": "2020/1/23",
        "tran": "",
    }, {
        "from": "柬埔寨",
        "to": "深圳",
        "time": "2020/1/28",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例12密切接触者",
    "zwhsjqj": "",
    "rbyy": "有确诊患者接触史",
    "bzzzytjd": "有确诊患者接触史",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "",
    "fbingsj": "2020/1/25",
    "fbrq": "2月2日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "25",
    "blh": "188",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在武汉停留",
    "bzzzytjd": "2020年1月22日从深圳经武汉到鄂州，25日驾车到江西，后返回深圳，",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/25",
    "fbrq": "2月2日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "31",
    "blh": "187",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "鄂州",
        "time": "2020/1/22",
        "tran": "",
    }, {
        "from": "鄂州",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在武汉停留",
    "bzzzytjd": "2020年1月15日从深圳经武汉到湖北鄂州，22日驾车到武汉，后乘车返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/28",
    "fbrq": "2月2日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "37",
    "blh": "186",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18——2020/1/19",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月18日前往武汉，19日从武汉到河南南阳，23日驾车到湖北孝感，25日返回南阳，26日从河南信阳前往深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/28",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/26",
    "fbrq": "2月2日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "41",
    "blh": "185",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "信阳",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例180女儿",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月20日驾车到湖北咸宁，23日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/30",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/29",
    "fbrq": "2月2日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "29",
    "blh": "184",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "咸宁",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21——2020/1/21",
    "rbyy": "在武汉停留",
    "bzzzytjd": "2020年1月21日从深圳到武汉，同日驾车从武汉到湖北天门，23日驾车到深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/28",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/28",
    "fbrq": "2月2日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "29",
    "blh": "183",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "天门",
        "time": "2020/1/21",
        "tran": "私家车",
    }, {
        "from": "天门",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2019年12月27日驾车前往湖北孝感，2020年2020年1月26日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "2020/1/26",
    "fbingsj": "2020/1/23",
    "fbrq": "2月2日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "46",
    "blh": "182",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/26",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "无湖北等地旅游史，无病例接触史",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/28",
    "lssj": "",
    "fbingsj": "2020/1/27",
    "fbrq": "2月2日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "33",
    "blh": "181",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '',
    "detailReason": ''
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月17日前往湖北咸宁，23日驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/26",
    "fbrq": "2月2日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "56",
    "blh": "180",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "咸宁",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月8日前往湖北枝江，24日驾车返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/28",
    "fbrq": "2月2日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "60",
    "blh": "179",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "枝江",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "origin": '湖北',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "病例94妻子",
    "zwhsjqj": "2020/1/8——2020/1/22",
    "rbyy": "武汉探亲",
    "bzzzytjd": "2020年1月8日至武汉探亲，22日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/24",
    "fbrq": "2月2日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "65",
    "blh": "178",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20——2020/1/22",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月20日前往武汉，22日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/28",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/28",
    "fbrq": "2月2日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "49",
    "blh": "177",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/15",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "2020/1/15",
    "fbingsj": "2020/1/22",
    "fbrq": "2月2日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "81",
    "blh": "176",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/15",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20——2020/1/22",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月20日前往武汉，22日返回深圳",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/29",
    "fbrq": "2月2日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "20",
    "blh": "175",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例166妻子",
    "zwhsjqj": "2020/1/17——2020/1/23",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "2020年1月17日驾车到武汉，23日驾车到井冈山，24日返回深圳",
    "bk": "目前病情稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/29",
    "fbrq": "2月2日",
    "jzd": "深圳市光明区",
    "fbusj": "12时",
    "nl": "60",
    "blh": "174",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "井冈山",
        "time": "2020/1/23",
        "tran": "私家车",
    }, {
        "from": "井冈山",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "origin": '湖北',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例167丈夫",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月24日驾车从深圳到湖北大冶市，25日返回深圳，",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/30",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/30",
    "fbrq": "2月2日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "45",
    "blh": "173",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "大冶",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "origin": '湖北',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/19",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前病情稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/23",
    "fbrq": "2月2日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "41",
    "blh": "172",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/19",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "与武汉来深人员接触",
    "bzzzytjd": "发病前2周内否认有外出旅游史，有武汉来深人员密切接触史",
    "bk": "目前病情危重",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "",
    "fbingsj": "2020/1/29",
    "fbrq": "2月2日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "66",
    "blh": "171",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "origin": '深圳',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/16——2020/1/21",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月16日，从深圳前往上海，并于当日乘车前往武汉探亲，2020年1月21日自驾前往湖北省天门市，2020年1月24日自驾返回深圳。",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/21",
    "fbrq": "2月1日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "38",
    "blh": "170",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "天门",
        "time": "2020/1/21",
        "tran": "私家车",
    }, {
        "from": "天门",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '探亲'
},
{
    "yqtblgx": "病例115儿子",
    "zwhsjqj": "",
    "rbyy": "与武汉亲属接触",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/28",
    "lssj": "",
    "fbingsj": "2020/1/24",
    "fbrq": "2月1日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "37",
    "blh": "169",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例127丈夫",
    "zwhsjqj": "——2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月20日，从武汉前往香港旅游，2020年1月23日从香港回到深圳。",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/25",
    "fbrq": "2月1日",
    "jzd": "",
    "fbusj": "12时",
    "nl": "70",
    "blh": "168",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "香港",
        "time": "2020/1/20",
        "tran": "",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北探亲",
    "bzzzytjd": "2020年1月24日自驾前往湖北大冶市探亲",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/27",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/27",
    "fbrq": "2月1日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "43",
    "blh": "167",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "大冶",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '探亲'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/17——2020/1/23",
    "rbyy": "武汉探亲",
    "bzzzytjd": "2020年1月17日自驾前往武汉探亲，23日到达江西省井冈山市，24日自驾返回深圳。",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/28",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/24",
    "fbrq": "2月1日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "62",
    "blh": "166",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "井冈山",
        "time": "2020/1/17",
        "tran": "私家车",
    }, {
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '探亲'
},
{
    "yqtblgx": "病例132儿子",
    "zwhsjqj": "2020/1/18——2020/1/23",
    "rbyy": "武汉探亲",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/28",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/27",
    "fbrq": "2月1日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "14",
    "blh": "165",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/23",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/25",
    "fbrq": "2月1日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "60",
    "blh": "164",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例162妻子",
    "zwhsjqj": "2020/1/18",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月10日从深圳前往湖北，后乘车到黄石市，2020年1月18日乘车前往武汉市武汉区出发深圳。",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "2020/1/18",
    "fbingsj": "2020/1/21",
    "fbrq": "2月1日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "46",
    "blh": "163",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18",
    "rbyy": "在湖北停留",
    "bzzzytjd": "2020年1月10日前往湖北省黄石市，2020年1月18日乘车前往武汉市武汉区，后出发深圳。",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "2020/1/18",
    "fbingsj": "2020/1/24",
    "fbrq": "2月1日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "48",
    "blh": "162",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "与武汉员工会议接触",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "",
    "fbingsj": "2020/1/15",
    "fbrq": "2月1日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "62",
    "blh": "161",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/24",
    "fbrq": "2月1日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "68",
    "blh": "160",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/17",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月17日从原籍京山经武汉前往深圳。",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/25",
    "lssj": "2020/1/17",
    "fbingsj": "2020/1/16",
    "fbrq": "2月1日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "54",
    "blh": "159",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/17",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月22日从武汉自驾到广东东莞",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/27",
    "lssj": "",
    "fbingsj": "2020/1/25",
    "fbrq": "2月1日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "32",
    "blh": "158",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "东莞",
        "time": "2020/1/22",
        "tran": "",
    }, {
        "from": "东莞",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在湖北停留多日",
    "bzzzytjd": "2020年1月17日自驾前往湖北孝感，2020年1月18日返回深圳。",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/28",
    "lssj": "2020/1/18",
    "fbingsj": "2020/1/24",
    "fbrq": "2月1日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "38",
    "blh": "157",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "与武汉亲属接触",
    "bzzzytjd": "亲属中有从武汉前来的，但无确诊病例",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/23",
    "fbrq": "2月1日",
    "jzd": "安徽省蚌埠市",
    "fbusj": "12时",
    "nl": "1",
    "blh": "156",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例114岳母",
    "zwhsjqj": "",
    "rbyy": "密切接触者",
    "bzzzytjd": "2020年1月16日前往湖南省冷水江市，2020年1月27日返回深圳。",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/28",
    "lssj": "2020/1/27",
    "fbingsj": "2020/1/25",
    "fbrq": "2月1日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "63",
    "blh": "155",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "冷水江",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖南',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例114妻子",
    "zwhsjqj": "",
    "rbyy": "湖南探亲",
    "bzzzytjd": "2020年1月22日前往湖南省冷水江市，2020年1月27日返回深圳。",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/28",
    "lssj": "2020/1/27",
    "fbingsj": "2020/1/26",
    "fbrq": "2月1日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "34",
    "blh": "154",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "冷水江",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖南',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例84丈夫",
    "zwhsjqj": "",
    "rbyy": "密切接触者",
    "bzzzytjd": "在密切接触者采样检测中发现，新型冠状病毒阳性",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/29",
    "lssj": "",
    "fbingsj": "",
    "fbrq": "2月1日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "58",
    "blh": "153",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21——2020/1/22",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/26",
    "fbrq": "2月1日",
    "jzd": "江苏省南京市",
    "fbusj": "12时",
    "nl": "56",
    "blh": "152",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例150女儿",
    "zwhsjqj": "2020/1/18——2020/1/23",
    "rbyy": "武汉探亲",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/25",
    "fbrq": "2月1日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "18",
    "blh": "151",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18——2020/1/23",
    "rbyy": "武汉探亲",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/25",
    "fbrq": "2月1日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "49",
    "blh": "150",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '探亲'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/19",
    "rbyy": "武汉停留，湖北探亲",
    "bzzzytjd": "2020年1月19日前往武汉，乘私家车到潜江探亲，2020年1月24日乘私家车返回深圳。",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/28",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/28",
    "fbrq": "2月1日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "33",
    "blh": "149",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "潜江",
        "time": "2020/1/19",
        "tran": "私家车",
    }, {
        "from": "潜江",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '探亲'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "与武汉亲属接触",
    "bzzzytjd": "接触从武汉来深的父母（都未确诊）",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/27",
    "lssj": "",
    "fbingsj": "2020/1/27",
    "fbrq": "2月1日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "38",
    "blh": "148",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例105女儿",
    "zwhsjqj": "2020/1/12——2020/1/22",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "在密切接触者采样检测中发现，新型冠状病毒阳性",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/28",
    "lssj": "2020/1/23",
    "fbingsj": "",
    "fbrq": "2月1日",
    "jzd": "深圳市罗湖区",
    "fbusj": "12时",
    "nl": "6",
    "blh": "147",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例29父亲",
    "zwhsjqj": "——2020/1/15",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月15日从武汉出发前往广西南宁旅游，2020年1月18日从广西南宁出发前往深圳探亲。",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/28",
    "lssj": "2020/1/18",
    "fbingsj": "2020/1/27",
    "fbrq": "2月1日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "76",
    "blh": "146",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "南宁",
        "time": "2020/1/15",
        "tran": "",
    }, {
        "from": "南宁",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/13——2020/1/23",
    "rbyy": "武汉探亲",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/27",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/26",
    "fbrq": "2月1日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "57",
    "blh": "145",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '探亲'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21——2020/1/23",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/24",
    "fbrq": "2月1日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "55",
    "blh": "144",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21——2020/1/23",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/28",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/25",
    "fbrq": "2月1日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "54",
    "blh": "143",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/28",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/22",
    "fbrq": "2月1日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "61",
    "blh": "142",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/16",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "2020/1/16",
    "fbingsj": "2020/1/26",
    "fbrq": "2月1日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "78",
    "blh": "141",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/16",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "——2020/1/22",
    "rbyy": "",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/28",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/23",
    "fbrq": "2月1日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "66",
    "blh": "140",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例138妻子",
    "zwhsjqj": "2020/1/16-2020/2/23",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/24",
    "fbrq": "2月1日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "57",
    "blh": "139",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/16-2020/2/23",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/26",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/26",
    "fbrq": "2月1日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "59",
    "blh": "138",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "男",
    "rysj": "2020/1/28",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/26",
    "fbrq": "2月1日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "56",
    "blh": "137",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例98女儿",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "在密切接触者采样检测中，发现新型冠状病毒阳性",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/27",
    "lssj": "",
    "fbingsj": "",
    "fbrq": "2月1日",
    "jzd": "湖北省十堰市",
    "fbusj": "12时",
    "nl": "4",
    "blh": "136",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "十堰",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/15",
    "rbyy": "武汉探亲",
    "bzzzytjd": "",
    "bk": "目前情况稳定",
    "xb": "女",
    "rysj": "2020/1/27",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/23",
    "fbrq": "2月1日",
    "jzd": "北京市",
    "fbusj": "12时",
    "nl": "47",
    "blh": "135",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '探亲'
},
{
    "yqtblgx": "病例129女儿",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/28",
    "lssj": "",
    "fbingsj": "2020/1/23",
    "fbrq": "1月31日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "25",
    "blh": "134",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例129丈夫",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "",
    "bk": "重症肺炎病例",
    "xb": "男",
    "rysj": "2020/1/28",
    "lssj": "",
    "fbingsj": "2020/1/24",
    "fbrq": "1月31日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "51",
    "blh": "133",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2019/1/18-2020/1/23",
    "rbyy": "武汉探亲",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/27",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/24",
    "fbrq": "1月31日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "39",
    "blh": "132",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '探亲'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/17",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月17日从武汉抵达昆明，25日抵达深圳",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/27",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/26",
    "fbrq": "1月31日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "6",
    "blh": "131",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "昆明",
        "time": "2020/1/17",
        "tran": "",
    }, {
        "from": "昆明",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/26",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/26",
    "fbrq": "1月31日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "65",
    "blh": "130",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "",
    "bzzzytjd": "发病史调查中",
    "bk": "重症肺炎病例",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "",
    "fbingsj": "2020/1/24",
    "fbrq": "1月31日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "49",
    "blh": "129",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '',
    "origin": '深圳',
    "detailReason": ''
},
{
    "yqtblgx": "",
    "zwhsjqj": "2019/1/16-2020/1/21",
    "rbyy": "武汉停留",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/26",
    "fbrq": "1月31日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "37",
    "blh": "128",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20",
    "rbyy": "武汉出发",
    "bzzzytjd": "2020年1月20日，该患者从武汉前往香港旅游，23日从香港回到深圳",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/25",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/23",
    "fbrq": "1月31日",
    "jzd": "",
    "fbusj": "12时",
    "nl": "66",
    "blh": "127",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "香港",
        "time": "2020/1/20",
        "tran": "",
    }, {
        "from": "香港",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/23",
    "rbyy": "湖北黄冈居住，武汉停留",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/25",
    "fbrq": "1月31日",
    "jzd": "湖北省黄冈市",
    "fbusj": "12时",
    "nl": "86",
    "blh": "126",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例98妻子",
    "zwhsjqj": "",
    "rbyy": "湖北黄冈停留",
    "bzzzytjd": "确诊患者密切接触者",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/27",
    "lssj": "2020/1/18",
    "fbingsj": "",
    "fbrq": "1月31日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "34",
    "blh": "125",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例98女儿",
    "zwhsjqj": "",
    "rbyy": "湖北黄冈停留",
    "bzzzytjd": "确诊患者密切接触者",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/27",
    "lssj": "2020/1/18",
    "fbingsj": "",
    "fbrq": "1月31日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "10",
    "blh": "124",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例97妻子",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "确诊患者密切接触者",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/27",
    "lssj": "2020/1/22",
    "fbingsj": "",
    "fbrq": "1月31日",
    "jzd": "湖北省十堰市",
    "fbusj": "12时",
    "nl": "64",
    "blh": "123",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "十堰",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/30",
    "lssj": "2020/1/18",
    "fbingsj": "2020/1/19",
    "fbrq": "1月31日",
    "jzd": "湖北省黄冈市",
    "fbusj": "12时",
    "nl": "57",
    "blh": "122",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '密切接触'
},
{
    "yqtblgx": "病例87女婿",
    "zwhsjqj": "",
    "rbyy": "与武汉岳父接触",
    "bzzzytjd": "确诊患者密切接触者",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "",
    "fbingsj": "2020/1/26",
    "fbrq": "1月31日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "39",
    "blh": "121",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例87女儿",
    "zwhsjqj": "",
    "rbyy": "与武汉父亲接触",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "",
    "fbingsj": "2020/1/26",
    "fbrq": "1月31日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "35",
    "blh": "120",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/17",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "2020/1/17",
    "fbingsj": "2020/1/20",
    "fbrq": "1月31日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "73",
    "blh": "119",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/17",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2019/1/11-2020/1/18",
    "rbyy": "武汉停留",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "2020/1/18",
    "fbingsj": "2020/1/20",
    "fbrq": "1月31日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "39",
    "blh": "118",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2019/1/13",
    "rbyy": "武汉停留",
    "bzzzytjd": "到达武汉后乘私车回到孝感市老家",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/27",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/23",
    "fbrq": "1月31日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "64",
    "blh": "117",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "孝感",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "武汉居住",
    "bzzzytjd": "其妻子在飞机上咳嗽、测体温略高",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "2020/1/27",
    "fbingsj": "2020/1/27",
    "fbrq": "1月31日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "49",
    "blh": "116",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/17",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/22",
    "lssj": "2020/1/17",
    "fbingsj": "2020/1/18",
    "fbrq": "1月31日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "64",
    "blh": "115",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/17",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "2020年1月16日从深圳前往湖南冷水江市探亲",
    "bzzzytjd": "2020年1月16日从深圳前往湖南冷水江市探亲， 27日从邵阳抵达深圳",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "2020/1/27",
    "fbingsj": "2020/1/19",
    "fbrq": "1月31日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "36",
    "blh": "114",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "冷水江",
        "to": "邵阳",
        "time": "2020/1/27",
        "tran": "",
    }, {
        "from": "邵阳",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖南',
    "reason": '密切接触',
    "detailReason": '探亲'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月18日从武汉出发前往马来西亚旅游，2020年1月27日从马来西亚抵达深圳，在机场体温检测时，连续两次体温检测结果显示不正常，随即入院就诊。",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "2020/1/27",
    "fbingsj": "2020/1/27",
    "fbrq": "1月31日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "53",
    "blh": "113",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "马来西亚",
        "time": "2020/1/18",
        "tran": "",
    }, {
        "from": "马来西亚",
        "to": "深圳",
        "time": "2020/1/27",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/24",
    "fbrq": "1月31日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "60",
    "blh": "112",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/13",
    "fbrq": "1月31日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "54",
    "blh": "111",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例76女儿",
    "zwhsjqj": "2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "在密切接触者采样检测中发现新型冠状病毒阳性",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "2020/1/21",
    "fbingsj": "",
    "fbrq": "1月30日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "2",
    "blh": "110",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例76母亲",
    "zwhsjqj": "",
    "rbyy": "与武汉亲属接触",
    "bzzzytjd": "在密切接触者采样检测中发现新型冠状病毒阳性",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "2020/1/21",
    "fbingsj": "",
    "fbrq": "1月30日",
    "jzd": "湖北省荆门市",
    "fbusj": "24时",
    "nl": "62",
    "blh": "109",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例76姐姐",
    "zwhsjqj": "",
    "rbyy": "与武汉亲属接触",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/29",
    "lssj": "",
    "fbingsj": "2020/1/28",
    "fbrq": "1月30日",
    "jzd": "深圳市宝安区",
    "fbusj": "24时",
    "nl": "38",
    "blh": "108",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例106母亲",
    "zwhsjqj": "2019/1/12-2020/1/22",
    "rbyy": "武汉停留",
    "bzzzytjd": "2020年1月22日自驾车从武汉开往河南信阳探亲，23日自驾车从河南信阳开往深圳",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/25",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/24",
    "fbrq": "1月30日",
    "jzd": "深圳市罗湖区",
    "fbusj": "24时",
    "nl": "61",
    "blh": "107",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "信阳",
        "time": "2020/1/22",
        "tran": "私家车",
    }, {
        "from": "信阳",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例105妻子",
    "zwhsjqj": "2019/1/17-2020/1/22",
    "rbyy": "武汉停留",
    "bzzzytjd": "2020年1月22日自驾车从武汉开往河南信阳探亲，23日自驾车从河南信阳开往深圳",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/25",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/24",
    "fbrq": "1月30日",
    "jzd": "深圳市罗湖区",
    "fbusj": "24时",
    "nl": "36",
    "blh": "106",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "信阳",
        "time": "2020/1/22",
        "tran": "私家车",
    }, {
        "from": "信阳",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例106丈夫",
    "zwhsjqj": "2019/1/17-2020/1/22",
    "rbyy": "武汉停留",
    "bzzzytjd": "2020年1月22日自驾车从武汉开往河南信阳探亲，23日自驾车从河南信阳开往深圳",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/23",
    "fbrq": "1月30日",
    "jzd": "深圳市罗湖区",
    "fbusj": "24时",
    "nl": "35",
    "blh": "105",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "信阳",
        "time": "2020/1/22",
        "tran": "私家车",
    }, {
        "from": "信阳",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2019/1/12-2020/1/23",
    "rbyy": "武汉停留",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/25",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/23",
    "fbrq": "1月30日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "67",
    "blh": "104",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2019/1/19-2020/1/23",
    "rbyy": "武汉停留",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/23",
    "fbrq": "1月30日",
    "jzd": "深圳市福田区",
    "fbusj": "24时",
    "nl": "56",
    "blh": "103",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例99朋友",
    "zwhsjqj": "",
    "rbyy": "与武汉朋友接触",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "",
    "fbingsj": "2020/1/26",
    "fbrq": "1月30日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "34",
    "blh": "102",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例99朋友",
    "zwhsjqj": "",
    "rbyy": "与武汉朋友接触",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "",
    "fbingsj": "2020/1/25",
    "fbrq": "1月30日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "32",
    "blh": "101",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例99朋友",
    "zwhsjqj": "",
    "rbyy": "与武汉朋友接触",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "",
    "fbingsj": "2020/1/23",
    "fbrq": "1月30日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "32",
    "blh": "100",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "2020/1/20",
    "fbingsj": "",
    "fbrq": "1月30日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "34",
    "blh": "99",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例97儿子",
    "zwhsjqj": "",
    "rbyy": "病例97于2020/1/22武汉返深后与其居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/26",
    "lssj": "",
    "fbingsj": "2020/1/24",
    "fbrq": "1月30日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "40",
    "blh": "98",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "居住湖北省十堰市",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/26",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/24",
    "fbrq": "1月30日",
    "jzd": "湖北省十堰市",
    "fbusj": "12时",
    "nl": "64",
    "blh": "97",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "十堰",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "2020/1/18",
    "fbingsj": "2020/1/23",
    "fbrq": "1月30日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "52",
    "blh": "96",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例94女儿",
    "zwhsjqj": "2019/1/11-2020/1/22",
    "rbyy": "到武汉探亲",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/24",
    "fbrq": "1月30日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "38",
    "blh": "95",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "origin": '湖北',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例95父亲",
    "zwhsjqj": "2019/1/8-2020/1/22",
    "rbyy": "到武汉探亲",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/23",
    "fbrq": "1月30日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "65",
    "blh": "94",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "origin": '深圳',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/25",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/23",
    "fbrq": "1月30日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "56",
    "blh": "93",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "曾接触过武汉来深人员",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "",
    "fbingsj": "",
    "fbrq": "1月30日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "63",
    "blh": "92",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "患者否认外出史",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "",
    "fbingsj": "2020/1/20",
    "fbrq": "1月30日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "64",
    "blh": "91",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '',
    "detailReason": ''
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "澳门泰国旅游，有武汉团友",
    "bzzzytjd": "",
    "bk": "病情危重",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/18",
    "fbrq": "1月30日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "69",
    "blh": "90",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '泰国',
    "reason": '密切接触',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2019/1/10-2020/1/22",
    "rbyy": "居住湖北",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/17",
    "fbrq": "1月30日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "64",
    "blh": "89",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "在新疆接待过武汉朋友",
    "bzzzytjd": "2020年1月10日-11日在新疆接待过武汉朋友，12日发病，16日到达上海",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/19",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/12",
    "fbrq": "1月30日",
    "jzd": "新疆维吾尔自治区伊宁市",
    "fbusj": "12时",
    "nl": "46",
    "blh": "88",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "新疆",
        "to": "上海",
        "time": "2020/1/11",
        "tran": "",
    }, {
        "from": "上海",
        "to": "深圳",
        "time": "2020/1/19",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '新疆',
    "reason": '密切接触',
},
{
    "yqtblgx": "病例120父亲",
    "zwhsjqj": "2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/24",
    "fbrq": "1月30日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "51",
    "blh": "87",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "居住湖北省荆州市",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/24",
    "lssj": "2020/1/12",
    "fbingsj": "2020/1/19",
    "fbrq": "1月29日",
    "jzd": "湖北省荆州市",
    "fbusj": "24时",
    "nl": "53",
    "blh": "86",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/12",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2019/1/9-2020/1/20",
    "rbyy": "在湖北省汉川市居住12天",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/23",
    "fbrq": "1月29日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "59",
    "blh": "85",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2019/1/19-2020/1/22",
    "rbyy": "在湖北省武汉市、仙桃市探亲",
    "bzzzytjd": "2020年1月19日在长沙",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/25",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/23",
    "fbrq": "1月29日",
    "jzd": "深圳市龙华区",
    "fbusj": "24时",
    "nl": "52",
    "blh": "84",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "仙桃",
        "time": "2020/1/22",
        "tran": "",
    }, {
        "from": "仙桃",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2019/1/12-2020/1/19",
    "rbyy": "武汉居住18天",
    "bzzzytjd": "2020年1月19日-23日从武汉出发马来西亚旅游",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/27",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/26",
    "fbrq": "1月29日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "39",
    "blh": "83",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "马来西亚",
        "time": "2020/1/23",
        "tran": "",
    }, {
        "from": "马来西亚",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2019/1/20-2020/1/22",
    "rbyy": "出差武汉",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/22",
    "fbrq": "1月29日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "26",
    "blh": "82",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/23",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月23日从武汉驾车前往长沙，随后抵达深圳",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/19",
    "fbrq": "1月29日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "56",
    "blh": "81",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "长沙",
        "time": "2020/1/23",
        "tran": "私家车",
    }, {
        "from": "长沙",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例29女儿",
    "zwhsjqj": "2020/1/18",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/22",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/21",
    "fbrq": "1月29日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "26",
    "blh": "80",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20-2020/1/21",
    "rbyy": "武汉旅游",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/22",
    "fbrq": "1月29日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "32",
    "blh": "79",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/23",
    "fbrq": "1月29日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "78",
    "blh": "78",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/19-2020/1/20",
    "rbyy": "武汉开会",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/23",
    "fbrq": "1月29日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "50",
    "blh": "77",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/22",
    "fbrq": "1月29日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "30",
    "blh": "76",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/11-2020/1/16",
    "rbyy": "曾在武汉停留",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/16",
    "fbingsj": "2020/1/20",
    "fbrq": "1月29日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "32",
    "blh": "75",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/16",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北停留',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例73妻子",
    "zwhsjqj": "2020/1/13",
    "rbyy": "武汉探亲",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "2020/1/13",
    "fbingsj": "2020/1/21",
    "fbrq": "1月29日",
    "jzd": "深圳市福田区",
    "fbusj": "12时",
    "nl": "52",
    "blh": "74",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/13",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例74丈夫",
    "zwhsjqj": "2020/1/13",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/23",
    "lssj": "2020/1/13",
    "fbingsj": "2020/1/20",
    "fbrq": "1月29日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "51",
    "blh": "73",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/13",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月20日从武汉前往北京，23日发病，25日从北京到郴州，后驾车抵达深圳并入院就诊。",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/25",
    "lssj": "2020/1/25",
    "fbingsj": "2020/1/23",
    "fbrq": "1月29日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "51",
    "blh": "72",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "北京",
        "time": "2020/1/20",
        "tran": "",
    }, {
        "from": "北京",
        "to": "郴州",
        "time": "2020/1/25",
        "tran": "",
    }, {
        "from": "郴州",
        "to": "深圳",
        "time": "2020/1/25",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/19-2020/1/22",
    "rbyy": "湖北武汉、孝感旅居",
    "bzzzytjd": "2020年1月22日-2020年1月24日在湖北孝感、湖南长沙旅居，24日从长沙抵达深圳",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/25",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/25",
    "fbrq": "1月29日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "35",
    "blh": "71",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "长沙",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/23",
    "fbrq": "1月29日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "29",
    "blh": "70",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "潜江",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '湖北居住',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例20儿媳",
    "zwhsjqj": "",
    "rbyy": "亲属传染",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "",
    "fbingsj": "2020/1/22",
    "fbrq": "1月29日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "49",
    "blh": "69",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "origin": '深圳',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例20儿子",
    "zwhsjqj": "",
    "rbyy": "亲属传染",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/26",
    "lssj": "",
    "fbingsj": "2020/1/24",
    "fbrq": "1月29日",
    "jzd": "深圳市龙岗区",
    "fbusj": "12时",
    "nl": "49",
    "blh": "68",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "origin": '深圳',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例20妻子",
    "zwhsjqj": "",
    "rbyy": "湖北省鄂州市居住",
    "bzzzytjd": "2020年1月19日从湖北潜江前往深圳",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/26",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/24",
    "fbrq": "1月29日",
    "jzd": "湖北省鄂州市",
    "fbusj": "12时",
    "nl": "66",
    "blh": "67",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "潜江",
        "to": "深圳",
        "time": "2020/1/19",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例6妻子",
    "zwhsjqj": "2019/12/26-2020/1/2",
    "rbyy": "武汉旅游",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/2",
    "fbingsj": "2020/1/23",
    "fbrq": "1月29日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "64",
    "blh": "66",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/2",
        "tran": "",
    }],
    "treatment_hospital": "",
    "origin": '湖北',
    "reason": '密切接触',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/17-2020/1/24",
    "rbyy": "武汉停留",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/25",
    "lssj": "2020/1/24",
    "fbingsj": "2020/1/24",
    "fbrq": "1月29日",
    "jzd": "深圳市龙华区",
    "fbusj": "12时",
    "nl": "38",
    "blh": "65",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/24",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/25",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/24",
    "fbrq": "1月29日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "64",
    "blh": "64",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "病例62妻子",
    "zwhsjqj": "2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/16",
    "fbrq": "1月28日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "58",
    "blh": "63",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "origin": '湖北',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "病例63丈夫",
    "zwhsjqj": "2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/23",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/16",
    "fbrq": "1月28日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "61",
    "blh": "62",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "origin": '湖北',
    "detailReason": '家庭传播'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/23",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/21",
    "fbrq": "1月28日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "19",
    "blh": "61",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18",
    "rbyy": "武汉居住",
    "bzzzytjd": "湖北省武汉市和深圳市福田区两地居住",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/23",
    "lssj": "2020/1/18",
    "fbingsj": "2020/1/17",
    "fbrq": "1月28日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "52",
    "blh": "60",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/23",
    "lssj": "2020/1/17",
    "fbingsj": "2020/1/19",
    "fbrq": "1月28日",
    "jzd": "湖北省荆州市",
    "fbusj": "24时",
    "nl": "66",
    "blh": "59",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "荆州",
        "to": "深圳",
        "time": "2020/1/17",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/6-2020/1/20",
    "rbyy": "武汉停留",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/21",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/20",
    "fbrq": "1月28日",
    "jzd": "深圳市宝安区",
    "fbusj": "24时",
    "nl": "51",
    "blh": "58",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "origin": '湖北',
    "detailReason": '武汉暴露'
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/11-2020/1/19",
    "rbyy": "武汉停留",
    "bzzzytjd": "2020年1月19日从武汉到长春，20日发病，22日从长春抵达深圳",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/20",
    "fbrq": "1月28日",
    "jzd": "深圳市南山区",
    "fbusj": "12时",
    "nl": "20",
    "blh": "57",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "长春",
        "time": "2020/1/19",
        "tran": "",
    }, {
        "from": "长春",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/19",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/22",
    "fbrq": "1月28日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "22",
    "blh": "56",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/19",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/23",
    "fbrq": "1月28日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "62",
    "blh": "55",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/24",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/19",
    "fbrq": "1月28日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "25",
    "blh": "54",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/11-2020/1/21",
    "rbyy": "武汉探亲",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/21",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/16",
    "fbrq": "1月28日",
    "jzd": "深圳市宝安区",
    "fbusj": "12时",
    "nl": "49",
    "blh": "53",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/14-2020/1/15",
    "rbyy": "武汉停留",
    "bzzzytjd": "2020年1月16日由武汉到海口，22日由海口抵达深圳",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/25",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/18",
    "fbrq": "1月28日",
    "jzd": "湖北省荆门市",
    "fbusj": "12时",
    "nl": "47",
    "blh": "52",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "海口",
        "time": "2020/1/16",
        "tran": "",
    }, {
        "from": "海口",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/24",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/23",
    "fbrq": "1月28日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "69",
    "blh": "51",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/25",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/23",
    "fbrq": "1月28日",
    "jzd": "湖北省武汉市",
    "fbusj": "12时",
    "nl": "52",
    "blh": "50",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2019/12/27-2020/1/21",
    "rbyy": "武汉探亲",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/22",
    "fbrq": "1月27日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "55",
    "blh": "49",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/23",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/21",
    "fbrq": "1月27日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "69",
    "blh": "48",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例25、26孙女",
    "zwhsjqj": "2020/1/17",
    "rbyy": "武汉居住，爷爷奶奶确诊",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/17",
    "fbingsj": "2020/1/24",
    "fbrq": "1月27日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "7",
    "blh": "47",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/17",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/19",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/21",
    "fbrq": "1月27日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "64",
    "blh": "46",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/22",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/22",
    "fbrq": "1月27日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "40",
    "blh": "45",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/16",
    "rbyy": "湖北省境内经武汉",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/16",
    "fbingsj": "2020/1/17",
    "fbrq": "1月27日",
    "jzd": "湖北省武穴市",
    "fbusj": "24时",
    "nl": "53",
    "blh": "44",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/16",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/13-2020/1/22",
    "rbyy": "在武汉停留多日",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/19",
    "fbrq": "1月27日",
    "jzd": "深圳市南山区",
    "fbusj": "24时",
    "nl": "62",
    "blh": "43",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/23",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/22",
    "fbrq": "1月27日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "41",
    "blh": "42",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/16",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月16日从武汉到湖北天门，23日由湖北天门抵达深圳。",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/24",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/14",
    "fbrq": "1月27日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "53",
    "blh": "41",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "天门",
        "time": "2020/1/16",
        "tran": "",
    }, {
        "from": "天门",
        "to": "深圳",
        "time": "2020/1/23",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "男",
    "rysj": "2020/1/22",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/22",
    "fbrq": "1月27日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "67",
    "blh": "40",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例13、14儿媳",
    "zwhsjqj": "",
    "rbyy": "为确诊病例密切接触者",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/22",
    "lssj": "",
    "fbingsj": "2020/1/22",
    "fbrq": "1月27日",
    "jzd": "深圳市龙岗区",
    "fbusj": "24时",
    "nl": "38",
    "blh": "39",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例22妻子",
    "zwhsjqj": "2020/1/18",
    "rbyy": "武汉居住，丈夫确诊",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "2020/1/18",
    "fbingsj": "2020/1/20",
    "fbrq": "1月27日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "54",
    "blh": "38",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/16-2020/1/19",
    "rbyy": "武汉停留",
    "bzzzytjd": "",
    "bk": "情况稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/23",
    "fbrq": "1月27日",
    "jzd": "深圳市宝安区",
    "fbusj": "24时",
    "nl": "78",
    "blh": "37",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/19",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/19",
    "fbrq": "1月26日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "61",
    "blh": "36",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "2020年1月22日，驾车从黄石出发，23日抵达深圳。",
    "bk": "病情较轻，情况稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "2020/1/23",
    "fbingsj": "2020/1/22",
    "fbrq": "1月26日",
    "jzd": "湖北省黄石市",
    "fbusj": "24时",
    "nl": "47",
    "blh": "35",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄石",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "私家车",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "origin": '湖北',
    "detailOrigin":'黄石',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/23",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/19",
    "fbrq": "1月26日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "34",
    "blh": "34",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较重，情况尚为稳定",
    "xb": "女",
    "rysj": "2020/1/23",
    "lssj": "2020/1/18",
    "fbingsj": "2020/1/19",
    "fbrq": "1月26日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "75",
    "blh": "33",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/23",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/20",
    "fbrq": "1月26日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "63",
    "blh": "32",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/22",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "女",
    "rysj": "2020/1/22",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/20",
    "fbrq": "1月26日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "32",
    "blh": "31",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/19",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/22",
    "fbrq": "1月26日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "21",
    "blh": "30",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/19",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例80母亲",
    "zwhsjqj": "2020/1/15",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月15日从武汉到广西南宁，18日从南宁到佛山，20日从佛山抵达深圳.",
    "bk": "病情较轻，情况稳定",
    "xb": "女",
    "rysj": "2020/1/22",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/21",
    "fbrq": "1月26日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "49",
    "blh": "29",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "南宁",
        "time": "2020/1/15",
        "tran": "",
    }, {
        "from": "南宁",
        "to": "佛山",
        "time": "2020/1/18",
        "tran": "",
    }, {
        "from": "佛山",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "2020年1月12日，从武汉到黄岗市蕲春县。",
    "bk": "病情较轻，情况稳定",
    "xb": "女",
    "rysj": "2020/1/24",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/17",
    "fbrq": "1月26日",
    "jzd": "湖北省黄冈市",
    "fbusj": "24时",
    "nl": "20",
    "blh": "28",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "黄冈",
        "time": "2020/1/12",
        "tran": "",
    }, {
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/12",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "",
    "rbyy": "湖北居住",
    "bzzzytjd": "2020年1月22日从蕲春县达到广东省东莞市。\"",
    "bk": "病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/23",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/19",
    "fbrq": "1月25日",
    "jzd": "湖北省黄冈市",
    "fbusj": "24时",
    "nl": "62",
    "blh": "27",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "黄冈",
        "to": "深圳",
        "time": "2020/1/22",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例25妻子",
    "zwhsjqj": "2020/1/17",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "女",
    "rysj": "2020/1/22",
    "lssj": "2020/1/17",
    "fbingsj": "2020/1/22",
    "fbrq": "1月25日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "64",
    "blh": "26",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/17",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例26丈夫",
    "zwhsjqj": "2020/1/17",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较重，情况尚为稳定",
    "xb": "男",
    "rysj": "2020/1/20",
    "lssj": "2020/1/17",
    "fbingsj": "2020/1/20",
    "fbrq": "1月25日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "66",
    "blh": "25",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/17",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/22",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/18",
    "fbrq": "1月25日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "61",
    "blh": "24",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/18",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/22",
    "lssj": "2020/1/18",
    "fbingsj": "2020/1/21",
    "fbrq": "1月25日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "46",
    "blh": "23",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例38丈夫",
    "zwhsjqj": "2020/1/18",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/22",
    "lssj": "2020/1/18",
    "fbingsj": "2020/1/19",
    "fbrq": "1月25日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "57",
    "blh": "22",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/17",
    "rbyy": "武汉停留",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/21",
    "lssj": "2020/1/17",
    "fbingsj": "2020/1/18",
    "fbrq": "1月25日",
    "jzd": "广东省佛山市",
    "fbusj": "24时",
    "nl": "42",
    "blh": "21",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/17",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/19",
    "rbyy": "来深途中在武汉逗留半小时",
    "bzzzytjd": "该病例是佛山籍人士，但收治在深圳市定点医院，因管辖权归属，计算在佛山新增病例中。",
    "bk": "病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/22",
    "lssj": "2020/1/19",
    "fbingsj": "2020/1/20",
    "fbrq": "1月24日",
    "jzd": "湖北省鄂州市",
    "fbusj": "24时",
    "nl": "73",
    "blh": "20",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/19",
        "tran": "",
    }],
    "treatment_hospital": "深圳市定点医院",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/15-2020/1/18",
    "rbyy": "随父母武汉旅游",
    "bzzzytjd": "",
    "bk": "目前病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/22",
    "lssj": "2020/1/22",
    "fbingsj": "2020/1/19",
    "fbrq": "1月24日",
    "jzd": "河北省邯郸市",
    "fbusj": "24时",
    "nl": "36",
    "blh": "19",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/18",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/13",
    "rbyy": "武汉居住",
    "bzzzytjd": "2020年1月18日从武汉至厦门",
    "bk": "病情较重，情况尚为稳定",
    "xb": "男",
    "rysj": "2020/1/21",
    "lssj": "2020/1/13",
    "fbingsj": "2020/1/18",
    "fbrq": "1月24日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "74",
    "blh": "18",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/21",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/21",
    "lssj": "2020/1/21",
    "fbingsj": "2020/1/21",
    "fbrq": "1月24日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "63",
    "blh": "17",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/21",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例7妻子",
    "zwhsjqj": "2020/1/15",
    "rbyy": "武汉居住，来深探亲",
    "bzzzytjd": "妻弟有咳嗽",
    "bk": "病情较轻，情况稳定",
    "xb": "女",
    "rysj": "2020/1/21",
    "lssj": "2020/1/15",
    "fbingsj": "2020/1/20",
    "fbrq": "1月24日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "62",
    "blh": "16",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/15",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/20",
    "rbyy": "武汉探亲返回中山途中在深被隔离",
    "bzzzytjd": "",
    "bk": "目前病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/20",
    "lssj": "2020/1/20",
    "fbingsj": "2020/1/20",
    "fbrq": "1月22日",
    "jzd": "广东省中山市",
    "fbusj": "24时",
    "nl": "46",
    "blh": "15",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/20",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北停留',
    "detailReason": '探亲',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例13丈夫",
    "zwhsjqj": "2020/1/12",
    "rbyy": "武汉居住",
    "bzzzytjd": "咳嗽、疲乏",
    "bk": "病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/19",
    "lssj": "2020/1/12",
    "fbingsj": "2020/1/15",
    "fbrq": "1月21日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "71",
    "blh": "14",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/12",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例14妻子",
    "zwhsjqj": "2020/1/12",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "女",
    "rysj": "2020/1/19",
    "lssj": "2020/1/12",
    "fbingsj": "2020/1/12",
    "fbrq": "1月21日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "64",
    "blh": "13",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/12",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例11丈夫",
    "zwhsjqj": "2020/1/15",
    "rbyy": "武汉居住",
    "bzzzytjd": "",
    "bk": "病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/19",
    "lssj": "2020/1/15",
    "fbingsj": "2020/1/12",
    "fbrq": "1月21日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "69",
    "blh": "12",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/15",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例12妻子",
    "zwhsjqj": "2020/1/15",
    "rbyy": "武汉居住",
    "bzzzytjd": "咳嗽",
    "bk": "目前病情较轻，情况稳定",
    "xb": "女",
    "rysj": "2020/1/19",
    "lssj": "2020/1/15",
    "fbingsj": "2020/1/4",
    "fbrq": "1月21日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "64",
    "blh": "11",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/15",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/17",
    "rbyy": "武汉居住，来深探亲",
    "bzzzytjd": "咽痛、咳嗽",
    "bk": "目前病情较轻，情况稳定",
    "xb": "女",
    "rysj": "2020/1/19",
    "lssj": "2020/1/17",
    "fbingsj": "2020/1/16",
    "fbrq": "1月21日",
    "jzd": "湖北省武汉市",
    "fbusj": "24时",
    "nl": "56",
    "blh": "10",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/17",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/16",
    "rbyy": "武汉居住，来深探亲",
    "bzzzytjd": "头晕",
    "bk": "目前病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/17",
    "lssj": "2020/1/16",
    "fbingsj": "2020/1/6",
    "fbrq": "1月20日",
    "jzd": "湖北省武汉市",
    "fbusj": "",
    "nl": "51",
    "blh": "9",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/16",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "",
    "zwhsjqj": "2020/1/15",
    "rbyy": "武汉居住，来深培训",
    "bzzzytjd": "全身酸痛、乏力、头晕",
    "bk": "目前病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/16",
    "lssj": "2020/1/15",
    "fbingsj": "2020/1/9",
    "fbrq": "1月20日",
    "jzd": "湖北省武汉市",
    "fbusj": "",
    "nl": "35",
    "blh": "8",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/15",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '湖北居住',
    "detailReason": '武汉暴露',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例16丈夫",
    "zwhsjqj": "2020/1/15",
    "rbyy": "武汉居住，来深探亲",
    "bzzzytjd": "低热、咳嗽、肌肉酸痛、乏力",
    "bk": "病情较重，情况尚为稳定。",
    "xb": "男",
    "rysj": "2020/1/15",
    "lssj": "2020/1/15",
    "fbingsj": "2020/1/11",
    "fbrq": "1月20日",
    "jzd": "湖北省武汉市",
    "fbusj": "",
    "nl": "62",
    "blh": "7",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/15",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例66丈夫",
    "zwhsjqj": "2019/12/29-2020/1/2",
    "rbyy": "到武汉旅游",
    "bzzzytjd": "发热",
    "bk": "病情危重，生命体征暂平稳",
    "xb": "男",
    "rysj": "2020/1/9",
    "lssj": "2020/1/2",
    "fbingsj": "2020/1/8",
    "fbrq": "1月20日",
    "jzd": "深圳市福田区",
    "fbusj": "",
    "nl": "63",
    "blh": "6",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/2",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例3母亲",
    "zwhsjqj": "",
    "rbyy": "病例4于2020/1/4武汉返深后与其居住",
    "bzzzytjd": "不适、咳嗽、偶有气喘",
    "bk": "目前病情较重，情况尚为稳定",
    "xb": "女",
    "rysj": "2020/1/14",
    "lssj": "",
    "fbingsj": "2020/1/8",
    "fbrq": "1月20日",
    "jzd": "深圳市",
    "fbusj": "",
    "nl": "63",
    "blh": "5",
    "nationality&native": [
        "",
        ""
    ],
    "track": [],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '深圳',
    "detailOrigin":'',
},
{
    "yqtblgx": "病例1外孙",
    "zwhsjqj": "2019/12/29-2020/1/4",
    "rbyy": "到武汉探亲",
    "bzzzytjd": "出现低烧、气促与胸腔积液症状。为家庭聚集性疫情。",
    "bk": "目前病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/11",
    "lssj": "2020/1/4",
    "fbingsj": "2020/1/1",
    "fbrq": "1月20日",
    "jzd": "国外",
    "fbusj": "",
    "nl": "10",
    "blh": "4",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/4",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例1女婿",
    "zwhsjqj": "2019/12/29-2020/1/4",
    "rbyy": "到武汉探亲",
    "bzzzytjd": "在武汉出现发热、全身肌肉酸痛、咽痛等症状。为家庭聚集性疫情。",
    "bk": "目前病情较轻，情况稳定",
    "xb": "男",
    "rysj": "2020/1/11",
    "lssj": "2020/1/4",
    "fbingsj": "2020/1/1",
    "fbrq": "1月20日",
    "jzd": "国外",
    "fbusj": "",
    "nl": "36",
    "blh": "3",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/4",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例1妻子",
    "zwhsjqj": "2019/12/29-2020/1/4",
    "rbyy": "到武汉探亲",
    "bzzzytjd": "在武汉出现发热、全身肌肉酸痛、咽痛等症状。为家庭聚集性疫情。",
    "bk": "目前病情较重，情况尚为稳定",
    "xb": "女",
    "rysj": "2020/1/10",
    "lssj": "2020/1/4",
    "fbingsj": "2020/1/4",
    "fbrq": "1月20日",
    "jzd": "深圳市南山区",
    "fbusj": "",
    "nl": "65",
    "blh": "2",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/4",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
},
{
    "yqtblgx": "病例2丈夫",
    "zwhsjqj": "2019/12/29-2020/1/4",
    "rbyy": "到武汉探亲",
    "bzzzytjd": "返深后出现全身乏力、发热。为家庭聚集性疫情。",
    "bk": "目前病情危重",
    "xb": "男",
    "rysj": "2020/1/10",
    "lssj": "2020/1/4",
    "fbingsj": "2020/1/3",
    "fbrq": "1月19日",
    "jzd": "深圳市南山区",
    "fbusj": "",
    "nl": "66",
    "blh": "1",
    "nationality&native": [
        "",
        ""
    ],
    "track": [{
        "from": "武汉",
        "to": "深圳",
        "time": "2020/1/4",
        "tran": "",
    }],
    "treatment_hospital": "",
    "reason": '密切接触',
    "detailReason": '家庭传播',
    "origin": '湖北',
    "detailOrigin":'武汉',
}
]
export default TrackJSON
